<template>
    <div class="container-fluid">
        <div class="row">
            <consultaprodutos v-bind:idtabela="idtabela" v-bind:showprtabela="showprtabela" v-bind:filtrotipo="tipopropesquisa"></consultaprodutos>
            <div class="container" style="margin-bottom: 15px;">
                <div class="row">
                    <div class="col-md-5 border-right" id="dv-titulo-relatorio" style="padding-top: 25px;">
                        <h6>
                            <i class="fa fa-file-text-o nao-imprimir" style="font-size: 28px; padding-right: 5px; font-style: italic;"></i>
                            RELATÓRIOS DE VENDAS
                        </h6>
                        <h6 v-if="parseInt(idrelatorio) === 1" class="sub-tit-relatorio"><i class="fa fa-cubes"></i> Vendas de produtos</h6>
                        <h6 v-else-if="parseInt(idrelatorio) === 2" class="sub-tit-relatorio"><i class="fa fa-line-chart"></i> Mapa de vendas</h6>
                        <h6 v-else-if="parseInt(idrelatorio) === 3" class="sub-tit-relatorio"><i class="fa fa-exchange"></i> Movimentos dos PDVs</h6>
                        <h6 v-else-if="parseInt(idrelatorio) === 4" class="sub-tit-relatorio"><i class="fa fa-wrench"></i> Vendas de serviços</h6>
                        <h6 v-else-if="parseInt(idrelatorio) === 5" class="sub-tit-relatorio"><i class="fa fa-users"></i> Vendas por clientes</h6>
                        <h6 v-else-if="parseInt(idrelatorio) === 6" class="sub-tit-relatorio"><i class="fa fa-user-secret"></i> Comissão de vendedores</h6>
                        <h6 v-else-if="parseInt(idrelatorio) === 7" class="sub-tit-relatorio"><i class="fa fa-dollar"></i> Tabela de preços</h6>
                        <h6 v-else-if="parseInt(idrelatorio) === 8" class="sub-tit-relatorio"><i class="fa fa-address-book"></i> Comissão de cobradores</h6>
                        <h6 v-else class="sub-tit-relatorio"></h6>
                    </div>
                    <div class="col-md-3 border-right nao-imprimir">
                        <span class="lblselect2">Filial:</span>
                        <select id="cbfilial" data-placeholder="Selecione uma filial" v-model="idfilial" data-allow-clear="true" style="width:100%;">
                        </select>                        
                    </div>
                    <div class="col-md-2 nao-imprimir">
                        <label for="eddtini">De:</label>
                        <div class="input-group">
                            <date-picker id="eddtini" v-model="dtini" :config="options" class="form-control form-control-sm"></date-picker>
                            <div class="input-group-append">
                                <span class="input-group-text"><i class="fa fa-calendar"></i></span>
                            </div>								
                        </div>                        
                    </div>
                    <div class="col-md-2 nao-imprimir">
                        <label for="eddtfim">até:</label>
                        <div class="input-group">
                            <date-picker id="eddtfim" v-model="dtfim" :config="options" class="form-control form-control-sm"></date-picker>
                            <div class="input-group-append">
                                <span class="input-group-text"><i class="fa fa-calendar"></i></span>
                            </div>																			
                        </div>                        
                    </div>                                                    
                </div>
            </div>
            <div class="container-fluid border-top border-bottom dvwhite">
                <!-- Opções de relatórios -->
                <div class="container" v-show="parseInt(idrelatorio) === 0">
                    <div class="row">
                        <div class="col-md-12">
                            <ul class="list-group list-group-flush">
                                <li v-show="mtdvisualizarel('040Z.020Z.005Z')" class="list-group-item list-group-item-action rounded item-lst-relatorio" @click.prevent="mtddefinerelatorio(5)">
                                    <div class="row">
                                        <div class="col-md-2 text-center">
                                            <i class="fa fa-users icones-relatorio"></i>                                            
                                        </div>
                                        <div class="col-md-10">
                                            <span class="tit-item-relatorio">Vendas por clientes</span><br>
                                            <span class="sub-tit-item-relatorio">Lista as vendas dos clientes detalhadas ou resumidas</span>
                                        </div>
                                    </div>
                                </li>                                
                                <li v-show="mtdvisualizarel('040Z.020Z.010Z')" class="list-group-item list-group-item-action rounded item-lst-relatorio" @click.prevent="mtddefinerelatorio(1)">
                                    <div class="row">
                                        <div class="col-md-2 text-center">
                                            <i class="fa fa-cubes icones-relatorio"></i>                                            
                                        </div>
                                        <div class="col-md-10">
                                            <span class="tit-item-relatorio">Vendas de produtos</span><br>
                                            <span class="sub-tit-item-relatorio">Lista as vendas de produtos</span>
                                        </div>
                                    </div>
                                </li>
                                <li v-show="mtdvisualizarel('040Z.020Z.015Z')" class="list-group-item list-group-item-action rounded item-lst-relatorio" @click.prevent="mtddefinerelatorio(4)">
                                    <div class="row">
                                        <div class="col-md-2 text-center">
                                            <i class="fa fa-wrench icones-relatorio"></i>                                            
                                        </div>
                                        <div class="col-md-10">
                                            <span class="tit-item-relatorio">Vendas de serviços</span><br>
                                            <span class="sub-tit-item-relatorio">Lista as vendas de serviços</span>
                                        </div>
                                    </div>
                                </li>                                
                                <li v-show="mtdvisualizarel('040Z.020Z.020Z')" class="list-group-item list-group-item-action rounded item-lst-relatorio" @click.prevent="mtddefinerelatorio(2)">
                                    <div class="row">
                                        <div class="col-md-2 text-center">
                                            <i class="fa fa-line-chart icones-relatorio"></i>                                                                                         
                                        </div>
                                        <div class="col-md-10">
                                            <span class="tit-item-relatorio">Mapa de vendas</span><br>
                                            <span class="sub-tit-item-relatorio">Mostra as informações vendas por período</span>
                                        </div>
                                    </div>
                                </li>
                                <li v-show="mtdvisualizarel('040Z.020Z.030Z')" class="list-group-item list-group-item-action rounded item-lst-relatorio" @click.prevent="mtddefinerelatorio(3)">
                                    <div class="row">
                                        <div class="col-md-2 text-center">
                                            <i class="fa fa-exchange icones-relatorio"></i>                                                                                         
                                        </div>
                                        <div class="col-md-10">
                                            <span class="tit-item-relatorio">Movimentos dos PDVs</span><br>
                                            <span class="sub-tit-item-relatorio">Lista todos os movimentos realizados nos PDVs</span>
                                        </div>
                                    </div>
                                </li>                                
                                <li v-show="mtdvisualizarel('040Z.020Z.040Z')" class="list-group-item list-group-item-action rounded item-lst-relatorio" @click.prevent="mtddefinerelatorio(6)">
                                    <div class="row">
                                        <div class="col-md-2 text-center">
                                            <i class="fa fa-user-secret icones-relatorio"></i>                                                                                         
                                        </div>
                                        <div class="col-md-10">
                                            <span class="tit-item-relatorio">Comissão de vendedores</span><br>
                                            <span class="sub-tit-item-relatorio">Lista as comissões de vendedores</span>
                                        </div>
                                    </div>
                                </li>
                                <li v-show="mtdvisualizarel('040Z.020Z.045Z')" class="list-group-item list-group-item-action rounded item-lst-relatorio" @click.prevent="mtddefinerelatorio(8)">
                                    <div class="row">
                                        <div class="col-md-2 text-center">
                                            <i class="fa fa-address-book icones-relatorio"></i>                                                                                         
                                        </div>
                                        <div class="col-md-10">
                                            <span class="tit-item-relatorio">Comissão de cobradores</span><br>
                                            <span class="sub-tit-item-relatorio">Lista as comissões de cobradores</span>
                                        </div>
                                    </div>
                                </li>
                                <li v-show="mtdvisualizarel('040Z.020Z.050Z')" class="list-group-item list-group-item-action rounded item-lst-relatorio" @click.prevent="mtddefinerelatorio(7)">
                                    <div class="row">
                                        <div class="col-md-2 text-center">
                                            <i class="fa fa-dollar icones-relatorio"></i>                                                                                         
                                        </div>
                                        <div class="col-md-10">
                                            <span class="tit-item-relatorio">Tabelas de preços</span><br>
                                            <span class="sub-tit-item-relatorio">Lista as tabelas de preços de produtos</span>
                                        </div>
                                    </div>
                                </li>                                 
                            </ul>                                                        
                        </div>
                        <div class="col-md-12 text-right" style="padding-top:15px;">
                            <router-link to="/">
                                <button type="button" class="btn btn-secondary btn-sm"><i class="fa fa-sign-out"></i> Sair do relatório</button>                            
                            </router-link>
                        </div>
                    </div>
                </div>
                <div class="container" v-show="parseInt(idrelatorio) === 1 || parseInt(idrelatorio) === 2 || parseInt(idrelatorio) === 3 || parseInt(idrelatorio) === 4 || parseInt(idrelatorio) === 5 || parseInt(idrelatorio) === 6 || parseInt(idrelatorio) === 7 || parseInt(idrelatorio) === 8">
                    <div class="row nao-imprimir">
                        <div v-show="parseInt(idrelatorio) === 1 || parseInt(idrelatorio) === 2" class="col-sm-12 col-md-3 col-lg-2">
                            <label for="edidproduto">Produto:</label>
                            <div class="input-group" style="z-index: 1;">
                                <input type="text" class="form-control form-control-sm" id="edidproduto" v-model="coddig" maxlength="20" v-on:blur="mtdlocalizarproduto(coddig)" v-on:keyup.13="mtdlocalizarproduto(coddig)" style="text-transform: uppercase;">
                                <div class="input-group-append">
                                    <a href="#" class="btn btn-info btn-sm btn-grupo-pesq" role="button" @click.prevent="mtdconsultarproduto()"><i class="fa fa-search" style="padding-top: 3px;"></i></a>
                                </div>
                            </div>
                        </div>
                        <div v-show="parseInt(idrelatorio) === 1 || parseInt(idrelatorio) === 2" class="col-sm-12 col-md-4 col-lg-6">
                            <label for="eddescricaoproduto">Descrição do produto:</label>
                            <input type="text" class="form-control form-control-sm" id="eddescricaoprodutoedicao" v-model="descricaoproduto" maxlength="100" style="font-weight: bold;" disabled>
                        </div>
                        <div v-show="parseInt(idrelatorio) === 1 || parseInt(idrelatorio) === 2 || parseInt(idrelatorio) === 4 || parseInt(idrelatorio) === 5" class="col-sm-12 col-md-4 col-lg-4">
                            <span class="lblselect2">Cliente:</span>
                            <select id="cbcliente" data-placeholder="Selecione um cliente" v-model="idcliente" data-allow-clear="true" style="width:100%;">
                            </select>
                        </div>                        
                        <div v-show="(parseInt(idrelatorio) === 1 || parseInt(idrelatorio) === 2 || parseInt(idrelatorio) === 4 || parseInt(idrelatorio) === 5 || parseInt(idrelatorio) === 6 || parseInt(idrelatorio) === 8)" class="col-sm-12 col-md-2 col-lg-2">
                            <span class="lblselect2">Rota:</span>
                            <select id="cbrota" v-model="idrota"
                                    data-placeholder="Selecione uma rota" data-allow-clear="true" style="width:100%;">
                            </select>
                        </div>                        
                        <div v-show="parseInt(idrelatorio) === 1 || parseInt(idrelatorio) === 2 || parseInt(idrelatorio) === 5 || parseInt(idrelatorio) === 7" class="col-sm-12 col-md-2 col-lg-2">
                            <span class="lblselect2">Marca:</span>
                            <select id="cbmarca" v-model="idmarca"
                                    data-placeholder="Selecione uma marca" data-allow-clear="true" style="width:100%;">
                            </select>
                        </div>
                        <div v-show="parseInt(idrelatorio) === 1 || parseInt(idrelatorio) === 2 || parseInt(idrelatorio) === 5 || parseInt(idrelatorio) === 7" class="col-sm-12 col-md-2 col-lg-2">
                            <span class="lblselect2">Grupo:</span>
                            <select id="cbgrupo" v-model="idgrupo"
                                    data-placeholder="Selecione um grupo" data-allow-clear="true" style="width:100%;">
                            </select>
                        </div>
                        <div v-show="parseInt(idrelatorio) === 1 || parseInt(idrelatorio) === 2 || parseInt(idrelatorio) === 5 || parseInt(idrelatorio) === 7" class="col-sm-12 col-md-2 col-lg-2">
                            <span class="lblselect2">Subgrupo:</span>
                            <select id="cbsubgrupo" v-model="idsubgrupo"
                                    data-placeholder="Selecione um subgrupo" data-allow-clear="true" style="width:100%;">
                            </select>
                        </div>
                        <div v-show="parseInt(idrelatorio) === 1 || parseInt(idrelatorio) === 2 || parseInt(idrelatorio) === 5 || parseInt(idrelatorio) === 7" class="col-sm-12 col-md-2 col-lg-2">
                            <span class="lblselect2">Setor:</span>
                            <select id="cbsetor" v-model="idsetor"
                                    data-placeholder="Selecione um setor" data-allow-clear="true" style="width:100%;">
                            </select>
                        </div>                        
                        <div v-show="parseInt(idrelatorio) === 1 || parseInt(idrelatorio) === 2 || parseInt(idrelatorio) === 4 || parseInt(idrelatorio) === 5 || parseInt(idrelatorio) === 6" class="col-sm-12 col-md-2 col-lg-2">
                            <span class="lblselect2">Vendedor:</span>
                            <select id="cbvendedor" v-model="idvendedor"
                                    data-placeholder="Selecione um vendedor" data-allow-clear="true" style="width:100%;">
                            </select>
                        </div>
                        <div v-show="parseInt(idrelatorio) === 8" class="col-sm-12 col-md-2 col-lg-2">
                            <span class="lblselect2">Cobrador:</span>
                            <select id="cbcobrador" v-model="idcobrador"
                                    data-placeholder="Selecione um cobrador" data-allow-clear="true" style="width:100%;">
                            </select>
                        </div>
                        <div v-show="parseInt(idrelatorio) === 5 || parseInt(idrelatorio) === 6 || parseInt(idrelatorio) === 8" class="col-sm-2 col-md-2 col-lg-2">
                            <label for="cbdetalhar">Detalhado:</label>
                            <select name="cbdetalhar" class="form-control form-control-sm" id="cbdetalhar" v-model="detalharcliente">
                                <option value="0">Não</option>
                                <option value="1">Sim</option>
                            </select>
                        </div>
                        <div v-show="(parseInt(idrelatorio) === 5 || parseInt(idrelatorio) === 6) && parseInt(detalharcliente) === 1 && parseInt(tpcomissao) !== 3" class="col-sm-2 col-md-2 col-lg-2">
                            <label for="cbtpdetalhecomissao">Detalhar por:</label>
                            <select name="cbtpdetalhecomissao" class="form-control form-control-sm" id="cbtpdetalhecomissao" v-model="tpdetalhecomissao">
                                <option value="0">Itens</option>
                                <option value="1">Vendas</option>
                            </select>
                        </div>                        
                        <div v-show="parseInt(idrelatorio) === 6" class="col-sm-2 col-md-2 col-lg-2">
                            <label for="cbtpcomissao">Tp. Comissão:</label>
                            <select name="cbtpcomissao" class="form-control form-control-sm" id="cbtpcomissao" v-model="tpcomissao">
                                <option value="0">Faturamento</option>
                                <option value="1">Venda externa</option>
                                <option value="2">Produto</option>
                                <option value="3">Liquidez</option>
                            </select>
                        </div>                                                 
                        <div v-show="parseInt(idrelatorio) === 4" class="col-sm-12 col-md-2 col-lg-2">
                            <span class="lblselect2">Técnico:</span>
                            <select id="cbtecnico" v-model="idtecnico"
                                    data-placeholder="Selecione um técnico" data-allow-clear="true" style="width:100%;">
                            </select>
                        </div> 
                        <div v-show="parseInt(idrelatorio) === 4" class="col-sm-12 col-md-2 col-lg-2">
                            <span class="lblselect2">Serviço:</span>
                            <select id="cbservico" v-model="idservico"
                                    data-placeholder="Selecione um serviço" data-allow-clear="true" style="width:100%;">
                            </select>
                        </div>                                                                        
                        <div v-show="parseInt(idrelatorio) === 1 || parseInt(idrelatorio) === 2 || parseInt(idrelatorio) === 7" class="col-sm-12 col-md-2 col-lg-2">
                            <span class="lblselect2">Tabela:</span>
                            <select id="cbtabela" v-model="idtabela"
                                    data-placeholder="Selecione um grupo" data-allow-clear="true" style="width:100%;">
                            </select>
                        </div>                        
                        <div v-show="parseInt(idrelatorio) === 7" class="col-sm-12 col-md-2 col-lg-2">
                            <label for="cbestoque">Estoque:</label>
                            <select id="cbestoque" v-model="idestoque"
                                    data-placeholder="Selecione uma opção" data-allow-clear="true" style="width:100%;">
                            </select>
                        </div>
                        <div v-show="parseInt(idrelatorio) === 7" class="col-sm-12 col-md-2 col-lg-2">
                            <label for="cbopestoque">Estoque:</label>
                            <select class="form-control form-control-sm" id="cbopestoque" v-model="opestoque">
                                <option value="0">Com saldo</option>
                                <option value="1">Sem saldo</option>
                                <option value="2">Geral</option>                                
                            </select>
                        </div>                           
                        <div v-show="parseInt(idrelatorio) === 1 || parseInt(idrelatorio) === 7" class="col-sm-12 col-md-2 col-lg-2">
                            <label for="cbordem">Ordem:</label>
                            <select class="form-control form-control-sm" id="cbordem" v-model="ordem">
                                <option v-bind:value="parseInt(idrelatorio) !== 7 ? 'order by i.idproduto asc' : 'order by 1 asc'">Código</option>
                                <option v-bind:value="parseInt(idrelatorio) !== 7 ? 'order by p.descricao asc' : 'order by 2 asc'">Descrição</option>
                                <option v-if="parseInt(idrelatorio) !== 7" value="order by 1 desc">Quantidade</option>
                                <option v-if="parseInt(idrelatorio) !== 7" value="order by 2 desc">Total venda</option>
                            </select>
                        </div>  
                        <div v-show="parseInt(idrelatorio) === 7" class="col-sm-12 col-md-2 col-lg-2">
                            <label for="cbopestoque">Preço:</label>
                            <select class="form-control form-control-sm" id="cbopestoque" v-model="oppreco">
                                <option value="0">Geral</option>
                                <option value="1">Auxiliar</option>                           
                            </select>
                        </div>                               
                        <div v-show="parseInt(idrelatorio) === 4" class="col-sm-12 col-md-2 col-lg-2">
                            <label for="cbordemserv">Ordem:</label>
                            <select class="form-control form-control-sm" id="cbordemserv" v-model="ordemserv">
                                <option value="order by 3 asc">Código</option>
                                <option value="order by 4 asc">Descrição</option>
                                <option value="order by 6 asc">Técnico</option>
                                <option value="order by 1 desc">Quantidade</option>
                                <option value="order by 2 desc">Total venda</option>
                            </select>
                        </div>                                                                      
                        <div v-show="parseInt(idrelatorio) === 2" class="col-sm-12 col-md-2 col-lg-2">
                            <span class="lblselect2">Município:</span>
                            <select id="cbmunicipios" v-model="idmunicipio"
                                    data-placeholder="Selecione uma cidade" data-allow-clear="true" style="width:100%;">
                            </select>
                        </div>
                        <div v-show="parseInt(idrelatorio) === 2" class="col-sm-12 col-md-2 col-lg-2">
                            <label for="cbagrupamento">Agrupar por:</label>
                            <select class="form-control form-control-sm" id="cbagrupamento" v-model="agrupamento">
                                <option value="0">Dia</option>
                                <option value="1">Mês</option>
                            </select>
                        </div>

                        <div v-show="parseInt(idrelatorio) === 2" class="col-sm-12 col-md-6 col-lg-6">
                            <label for="sbvisualizar">Visualizar:</label>
                            <select name="sbvisualizar" class="form-control form-control-sm selectpicker" id="sbvisualizar" multiple data-actions-box="true">
                                <option data-content="Vendas" value="0"></option>
                                <option data-content="Variação" value="1"></option>
                                <option data-content="Filiais" value="2"></option>
                                <option data-content="Formas pgto." value="3"></option>
                                <option data-content="Planos" value="4"></option>
                                <option data-content="Marca" value="5"></option>
                                <option data-content="Grupo" value="6"></option>
                                <option data-content="Subgrupo" value="7"></option>
                                <option data-content="Setor" value="8"></option>
                                <option data-content="Vendedores" value="9"></option>
                                <option data-content="Municipios" value="10"></option>
                            </select>
                        </div>

                        <div v-show="parseInt(idrelatorio) === 3" class="col-sm-12 col-md-4 col-lg-4">
                            <span class="lblselect2">PDV:</span>
                            <select id="cbpdv" v-model="idpdv"
                                    data-placeholder="Selecione um PDV" data-allow-clear="true" style="width:100%;">
                            </select>
                        </div>
                        <div v-show="parseInt(idrelatorio) === 3" class="col-12 col-sm-12 col-md-6 col-lg-6">
                            <label for="sbmovimentos">Movimentos:</label>
                            <select name="sbmovimentos" class="form-control form-control-sm selectpicker" id="sbmovimentos" multiple data-actions-box="true">
                                <option data-content="Aberturas"    value="0"></option>
                                <option data-content="Vendas"       value="1"></option>
                                <option data-content="Recebimentos" value="2"></option>
                                <option data-content="Entradas"     value="3"></option>
                                <option data-content="Saídas"       value="4"></option>
                                <option data-content="Fechamentos"  value="5"></option>
                            </select>
                        </div>                                               
                        <div v-show="parseInt(idrelatorio) === 3" class="col-sm-12 col-md-2 col-lg-2">
                            <label for="edidabertura">Código Abertura:</label>
                            <input type="number" class="form-control form-control-sm" id="edid" v-model="idabertura" maxlength="11"/>
                        </div>
                        <div v-show="parseInt(idrelatorio) === 3" class="col-sm-12 col-md-4 col-lg-4">
                            <span class="lblselect2">Grupo de saída:</span>
                            <select id="cbgruposaidapdv" v-model="idgruposaidapdv"
                                    data-placeholder="Selecione uma forma" data-allow-clear="true"
                                    style="width:100%;">
                            </select>
                        </div>                                                                                                                                                                         
                    </div>
                    <div class="row border-top border-bottom nao-imprimir" style="margin-top: 15px; padding-bottom: 15px;">
                        <div v-bind:class="parseInt(idrelatorio) !== 3 ? 'col-md-6': 'col-md-6'">
                        </div>                                      
                        <div class="col-md-2" style="padding-top: 15px;">
                            <button type="button" class="btn btn-primary btn-sm btn-block" @click.prevent="mtdexecutarelatorio(idrelatorio)"><i class="fa fa-search"></i> Listar</button>
                        </div>                                                                                          
                        <div class="col-md-2" style="padding-top: 15px;">
                            <button type="button" class="btn btn-secondary btn-sm btn-block" @click.prevent="mtddefinerelatorio(0)"><i class="fa fa-close"></i> Cancelar</button>
                        </div>
                        <!-- <div v-show="parseInt(idrelatorio) === 7" class="col-md-2" style="padding-top: 15px;">
                            <button type="button" class="btn btn-secondary btn-sm btn-block" @click.prevent="mtdimprimirtabelasprecos()"><i class="fa fa-print"></i> Imprimir</button>
                        </div> -->
                        <div v-show="parseInt(idrelatorio) === 7" class="col-md-2" style="padding-top: 15px;">                                                    
                            <div class="btn-group btn-block">
                                <button type="button" class="btn btn-secondary btn-sm dropdown-toggle" data-toggle="dropdown"><i class="fa fa-navicon"></i> Opções</button>
                                <div class="dropdown-menu">
                                    <a class="dropdown-item" href="#" @click.prevent="mtdopcoestabelasprecos(0, false)"><i class="fa fa-print"></i> Imprimir</a>
                                    <a class="dropdown-item" href="#" @click.prevent="mtdopcoestabelasprecos(1, false)"><i class="fa fa-file-excel-o"></i> Exportar excel</a>
                                    <a class="dropdown-item" href="#" @click.prevent="mtddefinirpaginicao()"><i class="fa fa-file-o"></i> Definir paginação</a>
                                </div>
                            </div>                        
                        </div>
                        <div v-show="parseInt(idrelatorio) !== 7" class="col-md-2" style="padding-top: 15px;">
                            <div class="dropdown">
                                <button type="button" class="btn btn-secondary btn-sm btn-block dropdown-toggle" data-toggle="dropdown">
                                    <i class="fa fa-navicon"></i> Outras
                                </button>
                                <div class="dropdown-menu">
                                    <a class="dropdown-item" href="#" @click.prevent="mtdexportarrelatorio(idrelatorio, 1)"><i class="fa fa-print"></i> Imprimir</a>
                                    <a class="dropdown-item" href="#" @click.prevent="mtdexportarrelatorio(idrelatorio, 2)"><i class="fa fa-file-excel-o"></i> Exportar excel</a>																			
                                </div>
                            </div>	
                        </div>  
                        <!-- <div v-if="parseInt(idrelatorio) !== 3" class="col-md-2" style="padding-top: 15px;">                            
                            <export-excel style="display: none;" id="btexportarexcel"
                                :data   = "parseInt(idrelatorio) === 1 ? lstvendasprodutos : 
                                           parseInt(idrelatorio) === 2 ? lstmapavendas : 
                                           parseInt(idrelatorio) === 4 ? lstvendasservicos : 
                                           parseInt(idrelatorio) === 5 ? lstvendasclientes: 
                                           parseInt(idrelatorio) === 6 ? lstvendedores:
                                           parseInt(idrelatorio) === 7 ? lsttabelasprecos : []"
                                name    = "relatorio.xls">
                            </export-excel>                                 
                            <button type="button" class="btn btn-info btn-sm btn-block" @click.prevent="mtdexportarexcel()"><i class="fa fa-file-excel-o"></i> Exportar</button>
                        </div>                                                                                                                         -->
                    </div>
                    <div class="row">
                        <div v-show="parseInt(idrelatorio) === 1 && lstvendasprodutos.length > 0" class="dvrodaperelatorios" style="padding-bottom: 0px;">
                            <div class="col-md-12 border-bottom" style="padding-top: 10px; padding-bottom: 10px;">
                                <div class="row">
                                    <div class="col-md-1">
                                        <span class="tit-item">Código</span>
                                    </div>
                                    <div class="col-md-3">
                                        <span class="tit-item">Descrição</span>
                                    </div>
                                    <div class="col-md-1">
                                        <span class="tit-item">Referência</span>
                                    </div>                               
                                    <div class="col-md-1 text-right">
                                        <span class="tit-item">Qtd. Ent</span>
                                    </div>                                                                        
                                    <div class="col-md-1 text-right">
                                        <span class="tit-item">Qtd. Venda</span>
                                    </div>                                             
                                    <div class="col-md-1 text-right">
                                        <span class="tit-item">Qtd. Atual</span>
                                    </div> 
                                    <div class="col-md-1 text-right">
                                        <span class="tit-item">Méd. Dia</span>
                                    </div> 
                                    <div class="col-md-1 text-right">
                                        <span class="tit-item">Tot. Custo</span>
                                    </div>                                                                                                                                                                                    
                                    <div class="col-md-1 text-right">
                                        <span class="tit-item">Tot. Venda</span>
                                    </div>                                                                        
                                    <div class="col-md-1 text-right">
                                        <span class="tit-item">Margem</span>
                                    </div>                                     
                                </div>
                            </div>                                                        
                        </div>
                        <div v-show="parseInt(idrelatorio) === 1" class="dvrelaconteudorelatorios" style="padding-bottom: 0px;">
                            <div v-for="(item, index) in lstvendasprodutos" v-bind:key="index" class="col-md-12 border-bottom item-rel-movprodutos">
                                <div class="row">
                                    <div class="col-md-1">
                                        <span class="tit-item-simples">{{item.idproduto}}</span>
                                    </div>
                                    <div class="col-md-3">
                                        <span class="tit-item">{{item.descricao}}</span>
                                    </div>
                                    <div class="col-md-1">
                                        <span class="tit-item">{{item.referencia}}</span>
                                    </div>                                    
                                    <div class="col-md-1 text-right">
                                        <span class="tit-item">{{item.qtdentrada}}</span>
                                    </div>                                                                                 
                                    <div class="col-md-1 text-right">
                                        <span class="tit-item">{{item.qtditem}}</span>
                                        <span class="tit-item-simples" style="margin-left: 5px;">{{item.und}}</span>
                                    </div>
                                    <div class="col-md-1 text-right">
                                        <span class="tit-item">{{item.estoque}}</span>
                                    </div>
                                    <div class="col-md-1 text-right">
                                        <span class="tit-item">{{item.mediadiaria}}</span>
                                    </div>                                                                                                                     
                                    <div class="col-md-1 text-right">
                                        <span class="tit-item-simples">{{mtdformatavalordecimal(parseFloat(item.totalgeralcustoitem), 2)}}</span>
                                    </div>                                                                                                            
                                    <div class="col-md-1 text-right">
                                        <span class="tit-item-simples">{{mtdformatavalordecimal(parseFloat(item.totalitem), 2)}}</span>
                                    </div>                                                                        
                                    <div class="col-md-1 text-right">
                                        <span class="tit-item">{{mtdformatavalordecimal(parseFloat(item.margem), 2)}}%</span>
                                    </div>                                    
                                </div>
                            </div>
                        </div>
                        <div v-show="parseInt(idrelatorio) === 1 && lstvendasprodutos.length > 0" class="dvrodaperelatorios">
                            <div class="col-md-12" style="padding-top: 15px;">
                                <div class="row">
                                    <div class="col-md-1 text-right">
                                        <span class="tit-item">ITENS: </span>
                                    </div>              
                                    <div class="col-md-1 text-right">
                                        <span class="tit-item-simples">{{qtditensprodutos}}</span>
                                    </div>                                                  
                                    <div class="col-md-2 text-right">
                                        <span class="tit-item">QUANTITATIVO: </span>
                                    </div>            
                                    <div class="col-md-1 text-right">
                                        <span class="tit-item-simples">{{quantitativoprodutos}}</span>
                                    </div>                                                    
                                    <div class="col-md-2 text-right">
                                        <span class="tit-item">TICKET MÉDIO:</span>
                                    </div>
                                    <div class="col-md-1 text-right">
                                        <span class="tit-item-simples">{{mtdformatavalordecimal(parseFloat(ticketmedioprodutos), 2)}}</span>
                                    </div> 
                                    <div class="col-md-2 text-right">
                                        <span class="tit-item">TOTAL CUSTO:</span>
                                    </div>                                
                                    <div class="col-md-1 text-right">
                                        <span class="tit-item">{{mtdformatavalordecimal(parseFloat(totalcustoprodutos), 2)}}</span>
                                    </div>                                                                                                                                                                                                                                                                     
                                    <div class="col-md-2 text-right">
                                        <span class="tit-item">TOTAL FATURADO:</span>
                                    </div>                                
                                    <div class="col-md-1 text-right">
                                        <span class="tit-item">{{mtdformatavalordecimal(parseFloat(totalvendasprodutos), 2)}}</span>
                                    </div>                                                                                                    
                                    <div class="col-md-2">
                                        <span class="tit-item">DIFERENÇA:</span>
                                    </div>                                
                                    <div class="col-md-1">
                                        <span class="tit-item">{{mtdformatavalordecimal(parseFloat(totalvendasprodutos) - parseFloat(totalcustoprodutos), 2)}}</span>
                                    </div>                           
                                    <div class="col-md-2">
                                        <span class="tit-item">MARGEM:</span>
                                    </div>                                
                                    <div class="col-md-1">
                                        <span class="tit-item">{{mtdformatavalordecimal((parseFloat(totalvendasprodutos) - parseFloat(totalcustoprodutos)) / parseFloat(totalcustoprodutos) * 100, 2)}}%</span>
                                    </div>                                    
                                </div>
                            </div>                            
                        </div> 
                        <div v-show="parseInt(idrelatorio) === 2 && lstmapavendas.length > 0  && vendas" class="dvrodaperelatorios" style="padding-bottom: 0px;">
                            <div class="col-md-12 border-bottom" style="padding-top: 10px; padding-bottom: 10px;">
                                <div class="row">  
                                    <div class="col-md-4">
                                        <span v-if="parseInt(agrupamento) === 0" class="tit-item">Dia</span>
                                        <span v-else class="tit-item">Mês</span>
                                    </div>
                                    <div class="col-md-2 text-right">
                                        <span class="tit-item">Total Custo</span>
                                    </div>                                             
                                    <div class="col-md-2 text-right">
                                        <span class="tit-item">Total Venda</span>
                                    </div>             
                                    <div class="col-md-2 text-right">
                                        <span class="tit-item">Diferença</span>
                                    </div>                                                                                                            
                                    <div class="col-md-2 text-right">
                                        <span class="tit-item">Margem</span>
                                    </div>                                             
                                </div>
                            </div>                                                        
                        </div>                                                   
                        <div v-show="parseInt(idrelatorio) === 2  && vendas" class="dvrelaconteudorelatorios" style="padding-bottom: 0px;">
                            <div v-for="(item, index) in lstmapavendas" v-bind:key="index" class="col-md-12 border-bottom item-rel-movprodutos">
                                <div class="row">
                                    <div class="col-md-4">
                                        <span class="tit-item">{{item.agrupamento}}</span>
                                    </div>                                          
                                    <div class="col-md-2 text-right">
                                        <span class="tit-item-simples">{{mtdformatavalordecimal(parseFloat(item.totalcusto), 2)}}</span>
                                    </div>   
                                    <div class="col-md-2 text-right">
                                        <span class="tit-item-simples">{{mtdformatavalordecimal(parseFloat(item.totalvenda), 2)}}</span>
                                    </div>                                                                                                          
                                    <div class="col-md-2 text-right">
                                        <span class="tit-item-simples">{{mtdformatavalordecimal(parseFloat(item.diferenca), 2)}}</span>
                                    </div>                                    
                                    <div class="col-md-2 text-right">
                                        <span class="tit-item">{{mtdformatavalordecimal(parseFloat(item.margem), 2)}}%</span>
                                    </div>                                             
                                </div>
                            </div>
                        </div> 
                        <div v-show="parseInt(idrelatorio) === 2 && lstmapavendas.length > 0 && vendas" class="dvrodaperelatorios">
                            <div class="col-md-12" style="padding-top: 15px;">
                                <div class="row">                                    
                                    <div class="col-md-4">
                                        <span class="tit-item">TOTALIZADORES</span>
                                    </div>                                     
                                    <div class="col-md-2 text-right">
                                        <span class="tit-item">{{mtdformatavalordecimal(parseFloat(totalgeralcusto), 2)}}</span>
                                    </div>   
                                    <div class="col-md-2 text-right">
                                        <span class="tit-item">{{mtdformatavalordecimal(parseFloat(totalgeralvenda), 2)}}</span>
                                    </div>                                                                                                          
                                    <div class="col-md-2 text-right">
                                        <span class="tit-item">{{mtdformatavalordecimal(parseFloat(totaldiferenca), 2)}}</span>
                                    </div>                                    
                                    <div class="col-md-2 text-right">
                                        <span class="tit-item">{{mtdformatavalordecimal(parseFloat(margemgeral), 2)}}%</span>
                                    </div>                                              
                                </div>
                            </div>                            
                        </div>
                        <!-- <div v-show="parseInt(idrelatorio) === 2" class="dvrodaperelatorios grafico-line-faturamento nao-imprimir">
                            <div class="col-md-12 border-top" style="padding-top: 15px;">
                                <div class="row">
                                    <div class="col-md-12" style="margin-top: 10px;">
                                        <div class="card">
                                            <div class="card-header card-dash">
                                                <span class="tit-card-dash">Mapa</span>
                                            </div>
                                            <div class="card-body" style="padding-bottom: 10px;">
                                                <div class="row">
                                                    <div class="col-md-12" style="margin-top: -40px;">
                                                        <graficomapa ></graficomapa>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>                    
                                    </div>
                                </div>
                            </div>    
                        </div> -->
                        <div v-show="parseInt(idrelatorio) === 2 && lstmapavendas.length > 0  && variacao" class="dvrodaperelatorios grafico-line-faturamento nao-imprimir">
                            <div class="col-md-12 border-top" style="padding-top: 15px;">
                                <div class="row">
                                    <div class="col-md-12" style="margin-top: 10px;">
                                        <div class="card">
                                            <div class="card-header card-dash">
                                                <span class="tit-card-dash">Variação do faturamento</span>
                                            </div>
                                            <div class="card-body" style="padding-bottom: 10px;">
                                                <div class="row">
                                                    <div class="col-md-12" style="margin-top: -40px;">
                                                        <graficoline :titulo="''"
                                                                        :agrupamento="agrupamentograficoline"
                                                                        :series="seriesgraficoline"
                                                        ></graficoline>
                                                    </div>
                                                    <!-- <div class="col-md-12">
                                                        <ul class="lista-card-graficos" style="padding-left: 0px; margin-bottom: 0px; margin-top: -40px; height: 61px; overflow:auto;">
                                                            <li v-for="(item, indice) in dadosfilial" :key="indice" class="li-item-card-dash" style="height: 15px;">
                                                                <span class="txt-item-card-dash-grafico">{{item.name }}</span>
                                                                <span class="txt-item-card-dash-grafico" style="float: right;">{{ mtdformatavalordecimal(parseFloat(item.value)) }} ({{ mtdformatavalordecimal(parseFloat(item.value) / parseFloat(totalgeralvenda) * 100, '') }}%)
                                                                </span>
                                                            </li>
                                                        </ul>                                            
                                                    </div> -->
                                                </div>
                                            </div>
                                        </div>                    
                                    </div>
                                </div>
                            </div>    
                        </div>
                        <div v-show="parseInt(idrelatorio) === 2 && lstmapavendas.length > 0" class="dvrodaperelatorios">
                            <div class="col-md-12 border-top" style="padding-top: 15px;">
                                <div class="row">
                                    <div v-show="filiais" class="col-md-6 nao-imprimir" style="margin-top: 10px;">
                                        <div class="card">
                                            <div class="card-header card-dash">
                                                <span class="tit-card-dash">Filiais</span>
                                            </div>
                                            <div class="card-body" style="padding-bottom: 10px;">
                                                <div class="row">
                                                    <div class="col-md-12" style="margin-top: -40px;">
                                                        <graficopie :rotulo="'DETALHES:'"
                                                                        :legendas="legendasfilial"
                                                                        :dados="dadosfilial"
                                                        ></graficopie>
                                                    </div>
                                                    <div class="col-md-12">
                                                        <ul class="lista-card-graficos" style="padding-left: 0px; margin-bottom: 0px; margin-top: -40px; height: 61px; overflow:auto;">
                                                            <li v-for="(item, indice) in dadosfilial" :key="indice" class="li-item-card-dash" style="height: 15px;">
                                                                <span class="txt-item-card-dash-grafico">{{item.name }}</span>
                                                                <span class="txt-item-card-dash-grafico" style="float: right;">{{ mtdformatavalordecimal(parseFloat(item.value)) }} ({{ mtdformatavalordecimal(parseFloat(item.value) / parseFloat(totalgeralvenda) * 100, '') }}%)
                                                                </span>
                                                            </li>
                                                        </ul>                                            
                                                    </div>
                                                </div>
                                            </div>
                                        </div>                    
                                    </div>                                                            
                                    <div v-show="vendedores" class="col-md-6 nao-imprimir" style="margin-top: 10px;">
                                        <div class="card">
                                            <div class="card-header card-dash">
                                                <span class="tit-card-dash">Vendedores</span>
                                            </div>
                                            <div class="card-body" style="padding-bottom: 10px;">
                                                <div class="row">
                                                    <div class="col-md-12" style="margin-top: -40px;">
                                                        <graficopie :rotulo="'DETALHES:'"
                                                                        :legendas="legendasvendedor"
                                                                        :dados="dadosvendedor"
                                                        ></graficopie>
                                                    </div>
                                                    <div class="col-md-12">
                                                        <ul class="lista-card-graficos" style="padding-left: 0px; margin-bottom: 0px; margin-top: -40px; height: 61px; overflow:auto;">
                                                            <li v-for="(item, indice) in dadosvendedor" :key="indice" class="li-item-card-dash" style="height: 15px;">
                                                                <span class="txt-item-card-dash-grafico">{{item.name }}</span>
                                                                <span class="txt-item-card-dash-grafico" style="float: right;">{{ mtdformatavalordecimal(parseFloat(item.value)) }} ({{ mtdformatavalordecimal(parseFloat(item.value) / parseFloat(totalgeralvenda) * 100, '') }}%)
                                                                </span>
                                                            </li>
                                                        </ul>                                            
                                                    </div>
                                                </div>
                                            </div>
                                        </div>                    
                                    </div>                                    
                                    <div v-show="formaspagto" class="col-md-6 nao-imprimir" style="margin-top: 10px;">
                                        <div class="card">
                                            <div class="card-header card-dash">
                                                <span class="tit-card-dash">Formas de pagamento</span>
                                            </div>
                                            <div class="card-body" style="padding-bottom: 10px;">
                                                <div class="row">
                                                    <div class="col-md-12" style="margin-top: -40px;">
                                                        <graficodoughnut :rotulo="'DETALHES:'"
                                                                        :legendas="legendasformas"
                                                                        :dados="dadosformas"
                                                        ></graficodoughnut>
                                                    </div>
                                                    <div class="col-md-12">
                                                        <ul class="lista-card-graficos" style="padding-left: 0px; margin-bottom: 0px; margin-top: -40px; height: 61px; overflow:auto;">
                                                            <li v-for="(item, indice) in dadosformas" :key="indice" class="li-item-card-dash" style="height: 15px;">
                                                                <span class="txt-item-card-dash-grafico">{{item.name }}</span>
                                                                <span class="txt-item-card-dash-grafico" style="float: right;">{{ mtdformatavalordecimal(parseFloat(item.value)) }} ({{ mtdformatavalordecimal(parseFloat(item.value) / parseFloat(totalgeralvenda) * 100, '') }}%)
                                                                </span>
                                                            </li>
                                                        </ul>                                            
                                                    </div>
                                                </div>
                                            </div>
                                        </div>                    
                                    </div>
                                    <div v-show="planos" class="col-md-6 nao-imprimir" style="margin-top: 10px;">
                                        <div class="card">
                                            <div class="card-header card-dash">
                                                <span class="tit-card-dash">Planos de pagamento</span>
                                            </div>
                                            <div class="card-body" style="padding-bottom: 10px;">
                                                <div class="row">
                                                    <div class="col-md-12" style="margin-top: -40px;">
                                                        <graficopie :rotulo="'DETALHES:'"
                                                                        :legendas="legendasplanos"
                                                                        :dados="dadosplanos"
                                                        ></graficopie>
                                                    </div>
                                                    <div class="col-md-12">
                                                        <ul class="lista-card-graficos" style="padding-left: 0px; margin-bottom: 0px; margin-top: -40px; height: 61px; overflow:auto;">
                                                            <li v-for="(item, indice) in dadosplanos" :key="indice" class="li-item-card-dash" style="height: 15px;">
                                                                <span class="txt-item-card-dash-grafico">{{item.name }}</span>
                                                                <span class="txt-item-card-dash-grafico" style="float: right;">{{ mtdformatavalordecimal(parseFloat(item.value)) }} ({{ mtdformatavalordecimal(parseFloat(item.value) / parseFloat(totalgeralvenda) * 100, '') }}%)
                                                                </span>
                                                            </li>
                                                        </ul>                                            
                                                    </div>
                                                </div>
                                            </div>
                                        </div>                    
                                    </div>                                                                                                                        
                                </div>
                            </div>    
                        </div>
                        <div v-show="parseInt(idrelatorio) === 2 && lstmapavendas.length > 0" class="dvrodaperelatorios grafico-individual">
                            <div class="col-md-12 border-top" style="padding-top: 15px;">
                                <div class="row">
                                    <div v-show="marcas" class="col-md-12 nao-imprimir" style="margin-top: 10px;">
                                        <div class="card">
                                            <div class="card-header card-dash">
                                                <span class="tit-card-dash">Marcas</span>
                                            </div>
                                            <div class="card-body" style="padding-bottom: 10px;">
                                                <div class="row">
                                                    <div class="col-md-12" style="margin-top: -40px;">
                                                        <graficopie :rotulo="'DETALHES:'"
                                                                        :legendas="legendasmarcas"
                                                                        :dados="dadosmarcas"
                                                        ></graficopie>
                                                    </div>
                                                    <div class="col-md-12">
                                                        <ul class="lista-card-graficos" style="padding-left: 0px; margin-bottom: 0px; margin-top: -40px; height: 200px; overflow:auto;">
                                                            <li v-for="(item, indice) in dadosmarcas" :key="indice" class="li-item-card-dash" style="height: 15px;">
                                                                <span class="txt-item-card-dash-grafico">{{item.name }}</span>
                                                                <span class="txt-item-card-dash-grafico" style="float: right;">{{ mtdformatavalordecimal(parseFloat(item.value)) }} ({{ mtdformatavalordecimal(parseFloat(item.value) / parseFloat(totalgeralvenda) * 100, '') }}%)
                                                                </span>
                                                            </li>
                                                        </ul>                                            
                                                    </div>
                                                </div>
                                            </div>
                                        </div>                    
                                    </div>                                                            
                                    <div v-show="grupos" class="col-md-12 nao-imprimir" style="margin-top: 10px;">
                                        <div class="card">
                                            <div class="card-header card-dash">
                                                <span class="tit-card-dash">Grupos</span>
                                            </div>
                                            <div class="card-body" style="padding-bottom: 10px;">
                                                <div class="row">
                                                    <div class="col-md-12" style="margin-top: -40px;">
                                                        <graficodoughnut :rotulo="'DETALHES:'"
                                                                        :legendas="legendasgrupos"
                                                                        :dados="dadosgrupos"
                                                        ></graficodoughnut>
                                                    </div>
                                                    <div class="col-md-12">
                                                        <ul class="lista-card-graficos" style="padding-left: 0px; margin-bottom: 0px; margin-top: -40px; height: 200px; overflow:auto;">
                                                            <li v-for="(item, indice) in dadosgrupos" :key="indice" class="li-item-card-dash" style="height: 15px;">
                                                                <span class="txt-item-card-dash-grafico">{{item.name }}</span>
                                                                <span class="txt-item-card-dash-grafico" style="float: right;">{{ mtdformatavalordecimal(parseFloat(item.value)) }} ({{ mtdformatavalordecimal(parseFloat(item.value) / parseFloat(totalgeralvenda) * 100, '') }}%)
                                                                </span>
                                                            </li>
                                                        </ul>                                            
                                                    </div>
                                                </div>
                                            </div>
                                        </div>                    
                                    </div>
                                    <div v-show="subgrupo" class="col-md-12 nao-imprimir" style="margin-top: 10px;">
                                        <div class="card">
                                            <div class="card-header card-dash">
                                                <span class="tit-card-dash">Subgrupos</span>
                                            </div>
                                            <div class="card-body" style="padding-bottom: 10px;">
                                                <div class="row">
                                                    <div class="col-md-12" style="margin-top: -40px;">
                                                        <graficopie :rotulo="'DETALHES:'"
                                                                        :legendas="legendassubgrupos"
                                                                        :dados="dadossubgrupos"
                                                        ></graficopie>
                                                    </div>
                                                    <div class="col-md-12">
                                                        <ul class="lista-card-graficos" style="padding-left: 0px; margin-bottom: 0px; margin-top: -40px; height: 200px; overflow:auto;">
                                                            <li v-for="(item, indice) in dadossubgrupos" :key="indice" class="li-item-card-dash" style="height: 15px;">
                                                                <span class="txt-item-card-dash-grafico">{{item.name }}</span>
                                                                <span class="txt-item-card-dash-grafico" style="float: right;">{{ mtdformatavalordecimal(parseFloat(item.value)) }} ({{ mtdformatavalordecimal(parseFloat(item.value) / parseFloat(totalgeralvenda) * 100, '') }}%)
                                                                </span>
                                                            </li>
                                                        </ul>                                            
                                                    </div>
                                                </div>
                                            </div>
                                        </div>                    
                                    </div>                                                                                                                        
                                    <div v-show="setor" class="col-md-12 nao-imprimir" style="margin-top: 10px;">
                                        <div class="card">
                                            <div class="card-header card-dash">
                                                <span class="tit-card-dash">Setores</span>
                                            </div>
                                            <div class="card-body" style="padding-bottom: 10px;">
                                                <div class="row">
                                                    <div class="col-md-12" style="margin-top: -40px;">
                                                        <graficopie :rotulo="'DETALHES:'"
                                                                        :legendas="legendassetores"
                                                                        :dados="dadossetores"
                                                        ></graficopie>
                                                    </div>
                                                    <div class="col-md-12">
                                                        <ul class="lista-card-graficos" style="padding-left: 0px; margin-bottom: 0px; margin-top: -40px; height: 200px; overflow:auto;">
                                                            <li v-for="(item, indice) in dadossetores" :key="indice" class="li-item-card-dash" style="height: 15px;">
                                                                <span class="txt-item-card-dash-grafico">{{item.name }}</span>
                                                                <span class="txt-item-card-dash-grafico" style="float: right;">{{ mtdformatavalordecimal(parseFloat(item.value)) }} ({{ mtdformatavalordecimal(parseFloat(item.value) / parseFloat(totalgeralvenda) * 100, '') }}%)
                                                                </span>
                                                            </li>
                                                        </ul>                                            
                                                    </div>
                                                </div>
                                            </div>
                                        </div>                    
                                    </div>
                                    <div v-show="municipios" class="col-md-12 nao-imprimir" style="margin-top: 10px;">
                                        <div class="card">
                                            <div class="card-header card-dash">
                                                <span class="tit-card-dash">Municipios</span>
                                            </div>
                                            <div class="card-body" style="padding-bottom: 10px;">
                                                <div class="row">
                                                    <div class="col-md-12" style="margin-top: -40px;">
                                                        <graficopie :rotulo="'DETALHES:'"
                                                                        :legendas="legendasmunicipios"
                                                                        :dados="dadosmunicipios"
                                                        ></graficopie>
                                                    </div>
                                                    <div class="col-md-12">
                                                        <ul class="lista-card-graficos" style="padding-left: 0px; margin-bottom: 0px; margin-top: -40px; height: 200px; overflow:auto;">
                                                            <li v-for="(item, indice) in dadosmunicipios" :key="indice" class="li-item-card-dash" style="height: 15px;">
                                                                <span class="txt-item-card-dash-grafico">{{item.name }}</span>
                                                                <span class="txt-item-card-dash-grafico" style="float: right;">{{ mtdformatavalordecimal(parseFloat(item.value)) }} ({{ mtdformatavalordecimal(parseFloat(item.value) / parseFloat(totalgeralvenda) * 100, '') }}%)
                                                                </span>
                                                            </li>
                                                        </ul>                                            
                                                    </div>
                                                </div>
                                            </div>
                                        </div>                    
                                    </div>                                                                                                                                           
                                </div>
                            </div>    
                        </div>
                        <div v-show="parseInt(idrelatorio) === 3" class="dvrodaperelatorios" style="padding-bottom: 0px;">
                            <div class="col-md-12 border-bottom" style="padding-top: 10px; padding-bottom: 10px;">
                                <div class="row">
                                    <div v-if="lstaberturas.length > 0" class="col-md-12 text-center" style="margin-bottom: 5px; margin-bottom: 5px; background: white;">
                                        <div class="col-md-12 border" style="border-radius: 5px;">
                                            <h6 style="margin: 5px;color: #666;">ABERTURA(S)</h6>
                                        </div>
                                    </div>							
                                    <div v-if="lstaberturas.length > 0" class="col-sm-12 table-responsive">
                                        <table class="table table-striped table-bordered table-sm table-hover" style="background: white;">
                                            <thead>
                                                <tr>
                                                    <th>Id. Lancamento</th>
                                                    <th>PDV</th>
                                                    <th>Dt. Abertura</th>
                                                    <th>Valor</th>
                                                    <th>Forma</th>
                                                    <th>Situação</th>
                                                    <th>Dt. Fechamento</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(abertura, i) in lstaberturas" v-bind:key="i">
                                                    <td>{{ mtdformatarzeros(abertura.id, 7) }}</td>
                                                    <td>{{abertura.descricaopdv}}</td>
                                                    <td class="text-right">{{ mtdformatardthr(abertura.dtabertura) }}</td>
                                                    <td class="text-right">{{ mtdformatavalordecimal(parseFloat(abertura.valorabertura), 2) }}</td>
                                                    <td>{{ abertura.descricaoforma }}</td>
                                                    <td class="text-center" v-if="parseInt(abertura.situacaopdv) === 0"><span class="badge badge-pill badge-primary" style="background: #727cf5;">ABERTO</span></td>
                                                    <td class="text-center" v-else><span class="badge badge-pill badge-success" style="background: #0acf97;">FECHADO</span></td>
                                                    <td v-if="parseInt(abertura.situacaopdv) === 1" class="text-right">{{mtdformatardthr(abertura.dtfechamento)}}</td>
                                                    <td v-else></td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div v-if="lstaberturas.length > 0" class="col-md-12" style="padding-bottom: 15px;">
                                        <ul class="list-group">
                                            <a class="list-group-item lstdettot">Total Aberturas <span class="badge badge-info bdg-totais">{{ mtdformatavalordecimal(ltotalaberturas, 2) }}</span></a>                                                                                                     
                                        </ul>
                                    </div>                                    
                                    <!-- Vendas -->
                                    <div v-if="lstvendas.length > 0" class="col-md-12 text-center" style="margin-bottom: 5px; margin-bottom: 5px; background: white;">
                                        <div class="col-md-12 border" style="border-radius: 5px;">
                                            <h6 style="margin: 5px;color: #666;">VENDAS</h6>
                                        </div>
                                    </div>						
                                    <div v-if="lstvendas.length > 0" class="col-sm-12 table-responsive" style="padding-bottom: 5px;">
                                        <table class="table table-striped table-bordered table-hover table-sm responsive" style="margin-bottom: 0px;">
                                            <thead>
                                            <tr>
                                                <th width="100">Nr. Venda</th>
                                                <th>Cliente</th>
                                                <th>Dt/Hr</th>
                                                <th>Plano</th>
                                                <th>Valor</th>										
                                                <th>Situação</th>
                                                <th>Formas pgto.</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr v-for="(pedido, indicep) in lstvendas" v-bind:key="indicep">
                                                <td style='vertical-align: middle; text-align: right;'>{{mtdformatarzeros(pedido.id, 8)}}</td>
                                                <td style='vertical-align: middle;'>{{mtdformatarzeros(pedido.idcliente,6)}} - {{pedido.nomecli}}</td>
                                                <td style='vertical-align: middle; text-align: right;'>{{pedido.dtfatura}}</td>
                                                <td style='vertical-align: middle;'>{{mtdformatarzeros(pedido.idplano,2)}} - {{pedido.descplano}}</td>
                                                <td style='vertical-align: middle; text-align: right;'>{{mtdformatavalordecimal(parseFloat(pedido.totalgeral), 2)}}</td>
                                                <td v-if="parseInt(pedido.stpedido) === 1" style='vertical-align: middle;' class="text-center"><span class="badge badge-secondary badge-pill" style="background-color: #5A956A;">FATURADO</span></td>
                                                <td v-else style='vertical-align: middle;' class="text-center"><span class="badge badge-danger badge-pill">CANCELADO</span></td>
                                                <td style="vertical-align: middle;">
                                                    <ul class="list-group">
                                                        <li v-for="(forma, indexf) in pedido.formas" v-bind:key="indexf" class="list-group-item d-flex justify-content-between align-items-center" style="padding: 2px;">
                                                            <span class="lblforma">{{forma.descricao}}</span>
                                                            <span class="lblforma">{{mtdformatavalordecimal(parseFloat(forma.valor), 2)}}</span>
                                                        </li>
                                                    </ul>
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div v-if="lstvendas.length > 0" class="col-md-12" style="padding-bottom: 15px;">
                                        <ul class="list-group">
                                            <a class="list-group-item lstdettot">Total Vendas <span class="badge badge-info bdg-totais">{{ mtdformatavalordecimal(ltotalvendas, 2) }}</span></a>                                                                                                     
                                        </ul>
                                        <ul v-if="parseFloat(ltotalcanceladas) > 0" class="list-group" style="margin-top: 5px;">
                                            <a class="list-group-item lstdettot">Total Canceladas <span class="badge badge-danger bdg-totais">{{ mtdformatavalordecimal(ltotalcanceladas, 2) }}</span></a>                                                                                                     
                                        </ul>                                        
                                    </div>
                                    <!-- Recebimentos -->
                                    <div v-if="lstrecebimentos.length > 0" class="col-md-12 text-center" style="margin-bottom: 5px; margin-bottom: 5px; background: white;">
                                        <div class="col-md-12 border" style="border-radius: 5px;">
                                            <h6 style="margin: 5px;color: #666;">RECEBIMENTOS</h6>
                                        </div>
                                    </div>						
                                    <div v-if="lstrecebimentos.length > 0" class="col-sm-12 table-responsive" style="padding-bottom: 5px;">
                                        <table class="table table-striped table-bordered table-hover table-sm responsive" style="margin-bottom: 0px;">
                                            <thead>
                                            <tr>
                                                <th width="100">Id. Mov</th>
                                                <th>Cliente</th>
                                                <th>Dt/Hr</th>
                                                <th>Valor</th>
                                                <th>Situação</th>
                                                <th>Formas pgto.</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr v-for="(recebimento, indicer) in lstrecebimentos" v-bind:key="indicer">
                                                <td style='vertical-align: middle; text-align: right;'>{{mtdformatarzeros(recebimento.idmovimento, 5)}}</td>
                                                <td style='vertical-align: middle;'>{{mtdformatarzeros(recebimento.idcliente, 6)}} - {{recebimento.nome}}</td>
                                                <td style='vertical-align: middle; text-align: right;'>{{recebimento.dthrlancamento}}</td>
                                                <td style='vertical-align: middle; text-align: right;'>{{mtdformatavalordecimal(recebimento.valor, 2)}}</td>
                                                <td v-if="parseInt(recebimento.situacao) === 0" style='vertical-align: middle;' class="text-center"></td>
                                                <td v-else style='vertical-align: middle;' class="text-center"><span class="badge badge-danger badge-pill">CANCELADO</span></td>
                                                <td style="vertical-align: middle;">
                                                    <ul class="list-group">
                                                        <li v-for="(forma, indexf) in recebimento.formas" v-bind:key="indexf" class="list-group-item d-flex justify-content-between align-items-center" style="padding: 2px;">
                                                            <span class="lblforma">{{forma.descricao}}</span>
                                                            <span class="lblforma">{{mtdformatavalordecimal(forma.valor, 2)}}</span>
                                                        </li>
                                                    </ul>
                                                </td>					
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div v-if="lstrecebimentos.length > 0" class="col-md-12" style="padding-bottom: 15px;">
                                        <ul class="list-group">
                                            <a class="list-group-item lstdettot">Total Recebimentos <span class="badge badge-info bdg-totais">{{ mtdformatavalordecimal(ltotalrecebimentos, 2) }}</span></a>                                                                                                     
                                        </ul>
                                    </div>
                                    <!-- Entradas -->
                                    <div v-if="lstentradas.length > 0" class="col-md-12 text-center" style="margin-bottom: 5px; margin-bottom: 5px; background: white;">
                                        <div class="col-md-12 border" style="border-radius: 5px;">
                                            <h6 style="margin: 5px;color: #666;">ENTRADAS</h6>
                                        </div>
                                    </div>						
                                    <div v-if="lstentradas.length > 0" class="col-sm-12 table-responsive" style="padding-bottom: 5px;">
                                        <table class="table table-striped table-bordered table-hover table-sm responsive"
                                            style="margin-bottom: 0px;">
                                            <thead>
                                            <tr>
                                                <th width="100">Id. Mov.</th>
                                                <th>Descrição</th>
                                                <th>Dt/Hr. lançto</th>
                                                <th>Valor</th>
                                                <th>Forma</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr v-for="(movimento, indiceme) in lstentradas" v-bind:key="indiceme">
                                                <td style='vertical-align: middle; text-align: right;'>{{mtdformatarzeros(movimento.idmovimento, 5)}}</td>
                                                <td style='vertical-align: middle;'>{{movimento.desclancamento}}</td>
                                                <td style='vertical-align: middle; text-align: right;'>{{movimento.dthrlancamento}}</td>
                                                <td style='vertical-align: middle; text-align: right;'>{{mtdformatavalordecimal(movimento.valor, 2)}}</td>
                                                <td style='vertical-align: middle;'>{{movimento.descforma}}</td>					
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div v-if="lstentradas.length > 0" class="col-md-12" style="padding-bottom: 15px;">
                                        <ul class="list-group">
                                            <a class="list-group-item lstdettot">Total Entradas <span class="badge badge-info bdg-totais">{{ mtdformatavalordecimal(ltotalentradas, 2) }}</span></a>                                                                                                     
                                        </ul>
                                    </div>
                                    <!-- Saídas -->
                                    <div v-if="lstsaidas.length > 0" class="col-md-12 text-center" style="margin-bottom: 5px; margin-bottom: 5px; background: white;">
                                        <div class="col-md-12 border" style="border-radius: 5px;">
                                            <h6 style="margin: 5px;color: #666;">SAÍDAS</h6>
                                        </div>
                                    </div>						
                                    <div v-if="lstsaidas.length > 0 && lstgrupossaidas.length <= 1" class="col-sm-12 table-responsive" style="padding-bottom: 5px;">
                                        <table class="table table-striped table-bordered table-hover table-sm responsive"
                                            style="margin-bottom: 0px;">
                                            <thead>
                                            <tr>
                                                <th width="100">Id. Mov.</th>
                                                <th>Descrição</th>
                                                <th>Grupo</th>
                                                <th>Dt/Hr. lançto</th>
                                                <th>Valor</th>
                                                <th>Forma</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr v-for="(movimento, indicems) in lstsaidas" v-bind:key="indicems">
                                                <td style='vertical-align: middle; text-align: right;'>{{mtdformatarzeros(movimento.idmovimento, 5)}}</td>
                                                <td style='vertical-align: middle;'>{{movimento.desclancamento}}</td>
                                                <td v-if="movimento.descgruposaida !== null" style='vertical-align: middle;'>{{movimento.descgruposaida}}</td>
                                                <td v-else></td>
                                                <td style='vertical-align: middle; text-align: right;'>{{movimento.dthrlancamento}}</td>
                                                <td style='vertical-align: middle; text-align: right;'>{{mtdformatavalordecimal(parseFloat(movimento.valor), 2)}}</td>
                                                <td style='vertical-align: middle;'>{{movimento.descforma}}</td>									
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>

                                    <!-- Saídas agrupadas-->
                                    <div v-if="lstgrupossaidas.length > 1" class="col-12">
                                        <div class="container-fluid">
                                            <div class="row">
                                                <div class="col-12" style="padding-bottom: 5px;">
                                                    <div v-for="(grupo, indgr) in lstgrupossaidas" v-bind:key="indgr" class="row border" style="padding: 5px; margin-top: 3px;">
                                                        <div class="col-10">
                                                            <span class="lstdettot">{{grupo.descgruposaida}}</span>
                                                        </div>
                                                        <div class="col-2 text-right">
                                                            <span class="lstdettot">{{mtdformatavalordecimal(parseFloat(grupo.valor), 2)}}</span>
                                                        </div>
                                                        <div class="col-12 table-responsive" style="padding-bottom: 5px; margin-top: 3px;">
                                                            <table class="table table-striped table-bordered table-hover table-sm responsive"
                                                                style="margin-bottom: 0px;">
                                                                <thead>
                                                                <tr>
                                                                    <th width="100">Id. Mov.</th>
                                                                    <th>Descrição</th>
                                                                    <th>Dt/Hr. lançto</th>
                                                                    <th>Valor</th>
                                                                    <th>Forma</th>
                                                                </tr>
                                                                </thead>
                                                                <tbody>
                                                                <tr v-for="(movimento, indicems) in grupo.lancamentos" v-bind:key="indicems">
                                                                    <td style='vertical-align: middle; text-align: right;'>{{mtdformatarzeros(movimento.idmovimento, 5)}}</td>
                                                                    <td style='vertical-align: middle;'>{{movimento.desclancamento}}</td>
                                                                    <td style='vertical-align: middle; text-align: right;'>{{movimento.dthrlancamento}}</td>
                                                                    <td style='vertical-align: middle; text-align: right;'>{{mtdformatavalordecimal(parseFloat(movimento.valor), 2)}}</td>
                                                                    <td style='vertical-align: middle;'>{{movimento.descforma}}</td>									
                                                                </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>                                                
                                                    </div>
                                                </div>                                    
                                            </div>    
                                        </div>    
                                    </div>    

                                    <div v-if="lstsaidas.length > 0" class="col-md-12" style="padding-bottom: 15px;">
                                        <ul class="list-group">
                                            <a class="list-group-item lstdettot">Total Saídas <span class="badge badge-info bdg-totais">{{ mtdformatavalordecimal(ltotalsaidas, 2) }}</span></a>                                                                                                     
                                        </ul>
                                    </div>
                                    <!-- Fechamento -->
                                    <div v-if="lstfechamentos.length > 0" class="col-md-12 text-center" style="margin-bottom: 5px; margin-bottom: 5px; background: white;">
                                        <div class="col-md-12 border" style="border-radius: 5px;">
                                            <h6 style="margin: 5px;color: #666;">FECHAMENTO(S)</h6>
                                        </div>
                                    </div>	
                                    <div v-if="lstfechamentos.length > 0" class="col-sm-12 table-responsive" style="padding-bottom: 15px;">
                                        <table class="table table-striped table-bordered table-hover table-sm responsive"
                                            style="margin-bottom: 0px;">
                                            <thead>
                                            <tr>
                                                <th width="30">Id.</th>
                                                <th>PDV</th>
                                                <th>Dt/Hr Fechamento</th>
                                                <th>Vl. fechamento</th>
                                                <th>Formas fechamento</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr v-for="(fechamento, i) in lstfechamentos" v-bind:key="i">
                                                <td style='vertical-align: middle; text-align: right;'>{{mtdformatarzeros(fechamento.idmovimento, 3)}}</td>
                                                <td style='vertical-align: middle;'>{{fechamento.descpdv}}</td>
                                                <td style='vertical-align: middle;'>{{fechamento.dthrlancamento}}</td>
                                                <td style='vertical-align: middle; text-align: right;'>{{mtdformatavalordecimal(fechamento.valor, 2)}}</td>									
                                                <td style="vertical-align: middle;">
                                                    <ul class="list-group">
                                                        <template v-for="(forma, indexf) in fechamento.formas">
                                                            <li v-if="parseFloat(forma.valor) > 0" v-bind:key="indexf" class="list-group-item d-flex justify-content-between align-items-center" style="padding: 2px;">
                                                                <span class="lblforma">{{forma.descricao}}</span>
                                                                <span class="lblforma">{{mtdformatavalordecimal(parseFloat(forma.valor), 2)}}</span>
                                                            </li>                                                            
                                                        </template>
                                                    </ul>
                                                </td>                                                
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>                                    														
                                    <div v-if="lstfechamentos.length > 0" class="col-sm-12 table-responsive" style="padding-bottom: 15px;">
                                        <table class="table table-striped table-bordered table-hover table-sm responsive"
                                            style="margin-bottom: 0px;">
                                            <thead>
                                            <tr>
                                                <th width="30">Id.</th>
                                                <th>Forma de pagamento</th>
                                                <th>Vl. registrado</th>
                                                <th>Vl. fechamento</th>
                                                <th>Diferença</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                                <template v-for="(forma, indicef) in lstformas">
                                                    <tr v-if="parseFloat(forma.valorfechamento).toFixed(2) > 0 && parseFloat(forma.valorregistrado).toFixed(2) !== 0" v-bind:key="indicef">
                                                        <td style='vertical-align: middle; text-align: right;'>{{mtdformatarzeros(forma.id, 3)}}</td>
                                                        <td style='vertical-align: middle;'>{{forma.descricao}}</td>
                                                        <td style='vertical-align: middle; text-align: right;'>{{mtdformatavalordecimal(forma.valorregistrado, 2)}}</td>									
                                                        <td style='vertical-align: middle; text-align: right;'>{{mtdformatavalordecimal(forma.valorfechamento, 2)}}</td>									
                                                        <td style='vertical-align: middle; text-align: right;'>{{mtdformatavalordecimal(parseFloat(forma.valorfechamento) - parseFloat(forma.valorregistrado), 2)}}</td>									
                                                    </tr>
                                                </template>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div v-if="lstfechamentos.length > 0" class="col-md-12">
                                        <div class="row">
                                            <div class="col-sm-12 col-md-4 col-lg-4">
                                                <ul class="list-group">
                                                    <a class="list-group-item lstdettot">Total registrado <span class="badge badge-primary bdg-totais">{{ mtdformatavalordecimal(ltotalregistrado, 2) }}</span></a>                                                                                                     
                                                </ul>
                                            </div>
                                            <div class="col-sm-12 col-md-4 col-lg-4">
                                                <ul class="list-group">
                                                    <a class="list-group-item lstdettot">Total fechamento<span class="badge badge-info bdg-totais">{{ mtdformatavalordecimal(ltotalfechamento, 2) }}</span></a>
                                                </ul>
                                            </div>
                                            <div class="col-sm-12 col-md-4 col-lg-4">
                                                <ul class="list-group">
                                                    <a class="list-group-item lstdettot">Total Diferença <span class="badge badge-info bdg-totais">{{ mtdformatavalordecimal(ltotaldiferenca, 2) }}</span></a>
                                                </ul>
                                            </div>			
                                        </div>					
                                    </div>                                    							                                    							                                                                                                            
                                </div>
                            </div>                                                        
                        </div>
                        <div v-show="parseInt(idrelatorio) === 4 && lstvendasservicos.length > 0" class="dvrodaperelatorios" style="padding-bottom: 0px;">
                            <div class="col-md-12 border-bottom" style="padding-top: 10px; padding-bottom: 10px;">
                                <div class="row">
                                    <div class="col-md-1">
                                        <span class="tit-item">Código</span>
                                    </div>
                                    <div class="col-md-5">
                                        <span class="tit-item">Descrição</span>
                                    </div>
                                    <div class="col-md-3">
                                        <span class="tit-item">Técnico</span>
                                    </div>                                                                           
                                    <div class="col-md-1 text-right">
                                        <span class="tit-item">Qtd. Venda</span>
                                    </div>                                             
                                    <div class="col-md-1 text-right">
                                        <span class="tit-item">Méd. Dia</span>
                                    </div> 
                                    <div class="col-md-1 text-right">
                                        <span class="tit-item">Tot. Venda</span>
                                    </div>                                                                                  
                                </div>
                            </div>                                                        
                        </div>
                        <div v-show="parseInt(idrelatorio) === 4" class="dvrelaconteudorelatorios" style="padding-bottom: 0px;">
                            <div v-for="(item, index) in lstvendasservicos" v-bind:key="index" class="col-md-12 border-bottom item-rel-movprodutos">
                                <div class="row">
                                    <div class="col-md-1">
                                        <span class="tit-item-simples">{{item.idservico}}</span>
                                    </div>
                                    <div class="col-md-5">
                                        <span class="tit-item">{{item.descricao}}</span>
                                    </div>
                                    <div class="col-md-3">
                                        <span class="tit-item">{{item.nometecnico}}</span>
                                    </div>                                                                                         
                                    <div class="col-md-1 text-right">
                                        <span class="tit-item">{{item.qtdservico}}</span>
                                        <span class="tit-item-simples" style="margin-left: 5px;">{{item.und}}</span>
                                    </div>
                                    <div class="col-md-1 text-right">
                                        <span class="tit-item">{{item.mediadiaria}}</span>
                                    </div>                                                                                                                                                                                                     
                                    <div class="col-md-1 text-right">
                                        <span class="tit-item-simples">{{mtdformatavalordecimal(parseFloat(item.totalservico), 2)}}</span>
                                    </div>                                                                                
                                </div>
                            </div>
                        </div>
                        <div v-show="parseInt(idrelatorio) === 4 && lstvendasservicos.length > 0" class="dvrodaperelatorios">
                            <div class="col-md-12" style="padding-top: 15px;">
                                <div class="row">
                                    <div class="col-md-1 text-right">
                                        <span class="tit-item">SERVIÇOS: </span>
                                    </div>              
                                    <div class="col-md-1 text-right">
                                        <span class="tit-item-simples">{{quantitativoservicos}}</span>
                                    </div>                                                                                                                                                                                                                                                                                           
                                    <div class="col-md-9 text-right">
                                        <span class="tit-item">TOTAL FATURADO:</span>
                                    </div>                                
                                    <div class="col-md-1 text-right">
                                        <span class="tit-item">{{mtdformatavalordecimal(parseFloat(totalvendasservicos), 2)}}</span>
                                    </div>                                                                                                    
                                </div>
                            </div>                            
                        </div>                        
                        <div v-show="parseInt(idrelatorio) === 4 && lstvendasservicos.length > 0" class="dvrodaperelatorios">
                            <div class="col-md-12 border-top" style="padding-top: 15px;">
                                <div class="row">
                                    <div class="col-md-4" style="margin-top: 10px;">
                                        <div class="card">
                                            <div class="card-header card-dash">
                                                <span class="tit-card-dash">Técnicos</span>
                                            </div>
                                            <div class="card-body" style="padding-bottom: 10px;">
                                                <div class="row">
                                                    <div class="col-md-12" style="margin-top: -40px;">
                                                        <graficopie :rotulo="'DETALHES:'"
                                                                        :legendas="legendastecnicos"
                                                                        :dados="dadostecnicos"
                                                        ></graficopie>
                                                    </div>
                                                    <div class="col-md-12">
                                                        <ul class="lista-card-graficos" style="padding-left: 0px; margin-bottom: 0px; margin-top: -40px; height: 61px; overflow:auto;">
                                                            <li v-for="(item, indice) in dadostecnicos" :key="indice" class="li-item-card-dash" style="height: 15px;">
                                                                <span class="txt-item-card-dash-grafico">{{item.name }}</span>
                                                                <span class="txt-item-card-dash-grafico" style="float: right;">{{ mtdformatavalordecimal(parseFloat(item.value)) }} ({{ mtdformatavalordecimal(parseFloat(item.value) / parseFloat(totalvendasservicos) * 100, '') }}%)
                                                                </span>
                                                            </li>
                                                        </ul>                                            
                                                    </div>
                                                </div>
                                            </div>
                                        </div>                    
                                    </div>                                                            
                                </div>
                            </div>    
                        </div>
                        <div v-show="parseInt(idrelatorio) === 5 && lstvendasclientes.length > 0" class="dvrodaperelatorios" style="padding-bottom: 0px;">
                            <div class="col-md-12 border-bottom" style="padding-top: 10px; padding-bottom: 10px;">
                                <div class="row">
                                    <div class="col-md-7">
                                        <span class="tit-item">Cliente</span>
                                    </div>                                                          
                                    <div class="col-md-1 text-right">
                                        <span class="tit-item">Qtd</span>
                                    </div>                                             
                                    <div class="col-md-1 text-right">
                                        <span class="tit-item">Tot. Custo</span>
                                    </div> 
                                    <div class="col-md-1 text-right">
                                        <span class="tit-item">Tot. Venda</span>
                                    </div>                               
                                    <div class="col-md-1 text-right">
                                        <span class="tit-item">Diferença</span>
                                    </div>
                                    <div class="col-md-1 text-right">
                                        <span class="tit-item">Perc(%)</span>
                                    </div>                                                                   									
                                </div>
                            </div>                                                        
                        </div>
                        <div v-show="parseInt(idrelatorio) === 5" class="dvrelaconteudorelatorios" style="padding-bottom: 0px;">
                            <div v-for="(item, index) in lstvendasclientes" v-bind:key="index" class="col-md-12 border-bottom item-rel-movprodutos">
                                <div class="row">
                                    <div class="col-md-7">
                                        <span class="tit-item">{{mtdformatarzeros(item.idcliente, 5)}} - {{item.nome}}</span>
                                    </div>                                                                        
                                    <div class="col-md-1 text-right">
                                        <span class="tit-item">{{item.qtdvendas}}</span>
                                    </div>
                                    <div class="col-md-1 text-right">
                                        <span class="tit-item-simples">{{mtdformatavalordecimal(parseFloat(item.totalcusto), 2)}}</span>
                                    </div>                                                                                                                                                                                                     
                                    <div class="col-md-1 text-right">
                                        <span class="tit-item">{{mtdformatavalordecimal(parseFloat(item.totalvenda), 2)}}</span>
                                    </div>                                                                                
                                    <div class="col-md-1 text-right">
                                        <span class="tit-item-simples">{{mtdformatavalordecimal(parseFloat(item.totalvenda) - parseFloat(item.totalcusto), 2)}}</span>
                                    </div>                           									
                                    <div class="col-md-1 text-right">
                                        <span class="tit-item">{{mtdformatavalordecimal(parseFloat(item.totalvenda) / parseFloat(totalgeralvendacliente) * 100, 2)}}</span>
                                    </div>
                                    <template v-if="parseInt(detalharcliente) === 1">
                                        <div v-for="(produto, ind) in item.itens" v-bind:key="ind" class="col-md-12 item-rel-movprodutos" style="padding: 2px;">                                    
                                            <div class="row">                                                                      
                                                <div class="col-md-7" style="padding-left: 75px;">
                                                    <span class="tit-item-simples">{{mtdformatarzeros(produto.idproduto, 6)}} - {{produto.descricao}}</span>
                                                </div>
                                                <div class="col-md-1 text-right">
                                                    <span class="tit-item-simples">{{produto.qtditem}} {{produto.und}}</span>
                                                </div>                                                                                                                                                                                                     
                                                <div class="col-md-1 text-right">
                                                    <span class="tit-item">{{mtdformatavalordecimal(parseFloat(produto.vltotal), 2)}}</span>
                                                </div>                                                                                                                           
                                            </div>
                                        </div>
                                    </template>
                                </div>
                            </div>
                        </div>
                        <div v-show="parseInt(idrelatorio) === 5 && lstvendasclientes.length > 0" class="dvrodaperelatorios">
                            <div class="col-md-12 border-top" style="padding-top: 15px;">
                                <div class="row">
                                    <div class="col-md-1 text-right">
                                        <span class="tit-item">Clientes: </span>
                                    </div>              
                                    <div class="col-md-1 text-right">
                                        <span class="tit-item-simples">{{lstvendasclientes.length}}</span>
                                    </div>                                                                                                                                                                                                                                                                                           
                                    <div class="col-md-2 text-right">
                                        <span class="tit-item">TOTAL CUSTO:</span>
                                    </div>                                
                                    <div class="col-md-1 text-right">
                                        <span class="tit-item">{{mtdformatavalordecimal(parseFloat(totalgeralcustocliente), 2)}}</span>
                                    </div>                                                                                                    
                                    <div class="col-md-2 text-right">
                                        <span class="tit-item">TOTAL VENDA:</span>
                                    </div>                                
                                    <div class="col-md-1 text-right">
                                        <span class="tit-item">{{mtdformatavalordecimal(parseFloat(totalgeralvendacliente), 2)}}</span>
                                    </div> 
                                    <div class="col-md-2 text-right">
                                        <span class="tit-item">DIFERENÇA:</span>
                                    </div>                                
                                    <div class="col-md-1 text-right">
                                        <span class="tit-item">{{mtdformatavalordecimal(parseFloat(totalgeralvendacliente) - parseFloat(totalgeralcustocliente), 2)}}</span>
                                    </div>									
                                </div>
                            </div>                            
                        </div> 
                        <div v-show="parseInt(idrelatorio) === 6 && lstvendedores.length > 0" class="dvrodaperelatorios" style="padding-bottom: 0px;">
                            <div class="col-md-12 border-bottom" style="padding-top: 10px; padding-bottom: 10px;">
                                <div class="row">
                                    <div class="col-md-1">
                                        <span class="tit-item">Id:</span>
                                    </div>								
                                    <div class="col-md-6">
                                        <span class="tit-item">Vendedor</span>
                                    </div>                                                                                 
                                    <div class="col-md-1 text-right">
                                        <span class="tit-item">Tot. Vendas</span>
                                    </div> 
                                    <div class="col-md-2 text-right">
                                        <span class="tit-item">Tot. Comissão</span>
                                    </div>                                                                       									
                                </div>
                            </div>                                                        
                        </div>
                        <div v-show="parseInt(idrelatorio) === 6" class="dvrelaconteudorelatorios" style="padding-bottom: 0px;">
                            <tempale v-if="parseInt(tpcomissao) !== 3">
                                <div v-for="(item, index) in lstvendedores" v-bind:key="index" class="col-md-12 border-bottom item-rel-movprodutos">
                                    <div class="row">                                                                     
                                        <div class="col-md-1">
                                            <span class="tit-item">{{item.idvendedor}}</span>
                                        </div>
                                        <div class="col-md-7">
                                            <span class="tit-item">{{item.nomevendedor}}</span>
                                        </div>									
                                        <div class="col-md-1 text-right">
                                            <span class="tit-item">{{mtdformatavalordecimal(parseFloat(item.totalvendedor), 2)}}</span>
                                        </div>                                                                                                                                                                                                     
                                        <div class="col-md-2 text-right">
                                            <span class="tit-item">{{mtdformatavalordecimal(parseFloat(item.totalcomissao), 2)}}</span>
                                        </div>                                                                                
                                        <template v-if="parseInt(detalharcliente) === 1 && parseInt(tpdetalhecomissao) === 0">
                                            <div v-for="(itemi, ind) in item.itens" v-bind:key="ind" class="col-md-12 item-rel-movprodutos" style="padding: 0px;">                                    
                                                <div class="row">                                                                      
                                                    <div class="col-md-1">
                                                    </div>
                                                    <div class="col-md-5">
                                                        <span class="tit-item-simples">{{mtdformatarzeros(itemi.id, 2)}} - {{itemi.descricao}}</span>
                                                    </div>                                                                                                                                                                          
                                                    <div class="col-md-1 text-right">
                                                        <span v-if="parseInt(tpcomissao) === 0 || parseInt(tpcomissao) === 2" class="tit-item-simples">{{itemi.qtditem}} {{itemi.und}}</span>
                                                    </div>                                                                                                                                                                           
                                                    <div class="col-md-1 text-right">
                                                        <span class="tit-item-simples">{{mtdformatavalordecimal(parseFloat(itemi.totalitem), 2)}}</span>
                                                    </div> 
                                                    <div class="col-md-1 text-right">
                                                        <span v-if="parseInt(tpcomissao) === 2" class="tit-item-simples">{{mtdformatavalordecimal(parseFloat(itemi.fatcomissao), 2)}}%</span>
                                                    </div>                                                                                                                              
                                                    <div class="col-md-2 text-right">
                                                        <span class="tit-item-simples">{{mtdformatavalordecimal(parseFloat(itemi.totalcomissao), 2)}}</span>
                                                    </div>                                                
                                                </div>
                                            </div>
                                        </template>
                                        <template v-if="parseInt(detalharcliente) === 1 && parseInt(tpdetalhecomissao) === 1">
                                            <div v-for="(itemi, ind) in item.vendas" v-bind:key="ind" class="col-md-12 item-rel-movprodutos" style="padding: 0px;">                                    
                                                <div class="row">                                                                      
                                                    <div class="col-md-1">
                                                    </div>
                                                    <div class="col-md-6">
                                                        <span class="tit-item-simples">{{mtdformatarzeros(itemi.id, 8)}} - {{itemi.nome}}</span>
                                                    </div>                                                                                                                                                                          
                                                    <div class="col-md-1 text-right">
                                                        <span class="tit-item-simples">{{itemi.dtfatura}}</span>
                                                    </div>                                                                                                                                                                           
                                                    <div class="col-md-1 text-right">
                                                        <span class="tit-item-simples">{{mtdformatavalordecimal(parseFloat(itemi.totalgeral), 2)}}</span>
                                                    </div>                                                                                                                           
                                                    <div class="col-md-2 text-right">
                                                        <span class="tit-item-simples">{{mtdformatavalordecimal(parseFloat(itemi.comissao), 2)}}</span>
                                                    </div>                                                
                                                </div>
                                            </div>
                                        </template>                                    
                                    </div>
                                </div>
                            </tempale>
                            <tempale v-else>
                                <div v-for="(item, index) in lstvendedores" v-bind:key="index" class="col-md-12 border-bottom item-rel-movprodutos" style="padding-bottom: 80px">
                                    <div class="row">                                                                     
                                        <div class="col-md-1">
                                            <span class="tit-item">{{item.idvendedor}}</span>
                                        </div>
                                        <div class="col-md-7">
                                            <span class="tit-item">{{item.nomevendedor}}</span>
                                        </div>									
                                        <div class="col-md-1 text-right">
                                            <span class="tit-item">{{mtdformatavalordecimal(parseFloat(item.totaltitisvendedor) + parseFloat(item.totalformasvendedor), 2)}}</span>
                                        </div>                                                                                                                                                                                                     
                                        <div class="col-md-2 text-right">
                                            <span class="tit-item">{{mtdformatavalordecimal(parseFloat(item.totalcomissao), 2)}}</span>
                                        </div>                                                                                
                                        <div v-if="parseInt(detalharcliente) === 1" class="col-md-12 border-bottom item-rel-movprodutos">
                                            <table class="table table-striped table-sm" >
                                                <thead>
                                                    <tr>
                                                        <th scope="col">PEDIDOS</th>
                                                        <th scope="col"></th>
                                                        <th scope="col"></th>
                                                        <th scope="col"></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(forma, ind) in item.formas" v-bind:key="ind">
                                                        <td style="font">{{ forma.idpedido }} - {{forma.nomecli}}</td>
                                                        <td>{{ forma.descforma }}</td>
                                                        <td style="text-align: right">{{mtdformatavalordecimal(parseFloat(forma.totalforma), 2)}}</td>
                                                        <td style="text-align: right">{{mtdformatavalordecimal(parseFloat(forma.totalcomissforma), 2)}}</td>
                                                    </tr>
                                                    <tr>
                                                        <td></td>
                                                        <td></td>
                                                        <td style="text-align: right; font-weight: bold;">{{mtdformatavalordecimal(parseFloat(item.totalformasvendedor), 2)}}</td>
                                                        <td style="text-align: right; font-weight: bold;">{{mtdformatavalordecimal(parseFloat(item.totalcomissaoformasvendedor), 2)}}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>    

                                        <div v-if="parseInt(detalharcliente) === 1" class="col-md-12 border-bottom">
                                            <table class="table table-striped table-sm">
                                                <thead>
                                                    <tr>
                                                        <th scope="col">TITULOS</th>
                                                        <th scope="col">EMIS:</th>
                                                        <th scope="col">VENC:</th>
                                                        <th scope="col">PGTO:</th>
                                                        <th scope="col"></th>
                                                        <th scope="col"></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr  v-for="(itemi, ind) in item.titulos" v-bind:key="ind">
                                                        <td>{{mtdformatarzeros(itemi.codtit, 2)}} - {{itemi.nomecli}}</td>
                                                        <td>{{ itemi.dtemitit }}</td>
                                                        <td>{{ itemi.dtventit }}</td>
                                                        <td>{{ itemi.dtpagtit }}</td>
                                                        <td style="text-align: right">{{mtdformatavalordecimal(parseFloat(itemi.totalpago), 2)}}</td>
                                                        <td style="text-align: right">{{mtdformatavalordecimal(parseFloat(itemi.totalcomisstit), 2)}}</td>
                                                    </tr>
                                                    <tr>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td style="text-align: right; font-weight: bold;">{{mtdformatavalordecimal(parseFloat(item.totaltitisvendedor), 2)}}</td>
                                                        <td style="text-align: right; font-weight: bold;">{{mtdformatavalordecimal(parseFloat(item.totalcomissaotitvendedor), 2)}}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <div v-if="parseInt(detalharcliente) === 1" class="col-12 border-top" style="padding-top: 15px;">
                                            <div class="row">                                                                                                                                                                                                                                                                
                                                <div class="col-md-8">
                                                    <span class="tit-item">TOTAIS:</span>
                                                </div>  
                                                <div class="col-md-2 text-right">
                                                    <span class="tit-item">{{mtdformatavalordecimal(parseFloat(item.totaltitisvendedor) + parseFloat(item.totalformasvendedor), 2)}}</span>
                                                </div>                                   
                                                <div class="col-md-2 text-right">
                                                    <span class="tit-item">{{mtdformatavalordecimal(parseFloat(item.totalcomissao), 2)}}</span>
                                                </div>                                                                                                    		                                                          
                                            </div>
                                        </div> 
                                    </div>
                                </div>
                            </tempale>
                        </div>
                        <div v-show="parseInt(idrelatorio) === 6 && lstvendedores.length > 0" class="dvrodaperelatorios">
                            <div class="col-md-12 border-top" style="padding-top: 15px;">
                                <div class="row">                                                                                                                                                                                                                                                                
                                    <div class="col-md-2">
                                        <span class="tit-item">TOTAIS:</span>
                                    </div>                                
                                    <div class="col-md-6 text-right">
                                        <span class="tit-item">{{mtdformatavalordecimal(parseFloat(totalgeralvenda), 2)}}</span>
                                    </div>                                                                                                    		
                                    <div class="col-md-2 text-right">
                                        <span class="tit-item">{{mtdformatavalordecimal(parseFloat(totalgeralcomissao), 2)}}</span>
                                    </div>                                                               
                                </div>
                            </div>                            
                        </div>
                        <div v-show="parseInt(idrelatorio) === 7 && lsttabelasprecos.length > 0" class="dvrodaperelatorios" style="padding-bottom: 0px;">
                            <div class="col-md-12 border-bottom" style="padding-top: 10px; padding-bottom: 10px;">
                                <div class="row">
                                    <div class="col-md-1">
                                        <span class="tit-item">Código</span>
                                    </div>
                                    <div class="col-md-4">
                                        <span class="tit-item">Descrição</span>
                                    </div>
                                    <div class="col-md-2">
                                        <span class="tit-item">Referência</span>
                                    </div>                               
                                    <div class="col-md-2">
                                        <span class="tit-item">Marca</span>
                                    </div>                                                                                        
                                    <div class="col-md-1 text-right">
                                        <span class="tit-item">Estoque</span>
                                    </div>           
                                    <div class="col-md-1 text-right">
                                        <span v-if="idtabela !== null" class="tit-item">Pr. Tabela</span>
                                        <span v-else class="tit-item">Tabelas</span>
                                    </div>                                    
                                </div>
                            </div>                                                        
                        </div>
                        <div v-show="parseInt(idrelatorio) === 7" class="dvrelaconteudorelatorios" style="padding-bottom: 0px;">
                            <div v-for="(item, index) in lsttabelasprecos" v-bind:key="index" class="col-md-12 border-bottom item-rel-movprodutos">
                                <div class="row">
                                    <div class="col-md-1">
                                        <span class="tit-item-simples">{{item.idproduto}}</span>                                        
                                    </div>
                                    <div class="col-md-4">                                        
                                        <span class="tit-item">{{item.descproduto}}</span>
                                    </div>
                                    <div class="col-md-2">
                                        <span class="tit-item">{{item.referencia}}</span>
                                    </div>                    
                                    <div class="col-md-2">
                                        <span class="tit-item">{{item.descmarca}}</span>
                                    </div>                                                                                                                                                                         
                                    <div class="col-md-1 text-right">
                                        <span class="tit-item">{{item.qtditem}}</span>
                                        <span class="tit-item-simples" style="margin-left: 5px;">{{item.und}}</span>
                                    </div> 
                                    <div class="col-md-2 text-right">
                                        <template v-if="idfilial !== null && idtabela !== null">
                                            <span class="tit-item"> {{mtdformatavalordecimal(parseFloat(item.prtabela), 2)}}</span>
                                            <span v-if="parseFloat(item.vldescpromocional) > 0" style="float: left;" class="badge badge-pill badge-primary" title="Tabela com desconto promocional">DP</span>
                                        </template>
                                        <template v-else-if="idfilial !== null && idtabela === null">                                            
                                            <ul class="list-group">
                                                <li v-for="(tabela, indexf) in item.tabelas" v-bind:key="indexf" class="list-group-item d-flex justify-content-between align-items-center" style="padding: 2px;">
                                                    <span class="lblforma-rel-tb">{{tabela.desctabela}}</span>
                                                    <span class="lblforma-rel-tb-vl">
                                                        {{mtdformatavalordecimal(parseFloat(tabela.prtabela), 2)}} 
                                                        <span v-if="parseFloat(tabela.vldescpromocional) > 0" class="badge badge-pill badge-primary bdg-desc-prom" title="Tabela com desconto promocional">DP</span>
                                                    </span>
                                                </li>
                                            </ul>                                            
                                        </template>
                                        <template v-else-if="idfilial === null && idtabela !== null">
                                            <span v-if="parseFloat(item.vldescpromocional) > 0" style="float: left;" class="badge badge-pill badge-primary" title="Tabela com desconto promocional">DP</span>                                            
                                            <span class="tit-item">{{mtdformatavalordecimal(parseFloat(item.prtabela), 2)}}</span>                                                                                        
                                        </template>
                                        <template v-else>
                                            <ul class="list-group">
                                                <li v-for="(tabela, indexf) in item.tabelas" v-bind:key="indexf" class="list-group-item d-flex justify-content-between align-items-center" style="padding: 2px;">
                                                    <span class="lblforma-rel-tb">{{tabela.desctabela}}</span>
                                                    <span class="lblforma-rel-tb-vl">
                                                        {{mtdformatavalordecimal(parseFloat(tabela.prtabela), 2)}}
                                                        <span v-if="parseFloat(tabela.vldescpromocional) > 0" class="badge badge-pill badge-primary bdg-desc-prom" title="Tabela com desconto promocional">DP</span>
                                                    </span>                                                    
                                                </li>
                                            </ul>                                            
                                        </template>
                                    </div>                                            
                                </div>
                            </div>
                        </div>
                        <div v-show="parseInt(idrelatorio) === 7 && lsttabelasprecos.length > 0" class="dvrodaperelatorios">
                            <div class="col-md-12" style="padding-top: 15px;">
                                <div class="row">
                                    <div class="col-md-1">
                                        <span class="tit-item">ITENS: </span>
                                    </div>              
                                    <div class="col-md-1 text-right">
                                        <span class="tit-item-simples">{{lsttabelasprecos.length}}</span>
                                    </div>                                                                                              
                                </div>
                            </div>                            
                        </div>  
                        <div v-show="parseInt(idrelatorio) === 8 && lstcobradores.length > 0" class="dvrodaperelatorios" style="padding-bottom: 0px;">
                            <div class="col-md-12 border-bottom" style="padding-top: 10px; padding-bottom: 10px;">
                                <div class="row">
                                    <div class="col-md-1">
                                        <span class="tit-item">Id:</span>
                                    </div>								
                                    <div class="col-md-6">
                                        <span class="tit-item">Cobrador</span>
                                    </div>                                                                                 
                                    <div class="col-md-1 text-right">
                                        <span class="tit-item">Tot. Titulos</span>
                                    </div> 
                                    <div class="col-md-2 text-right">
                                        <span class="tit-item">Tot. Comissão</span>
                                    </div>                                                                       									
                                </div>
                            </div>                                                        
                        </div>
                        <div v-show="parseInt(idrelatorio) === 8" class="dvrelaconteudorelatorios" style="padding-bottom: 0px;">
                            <div v-for="(item, index) in lstcobradores" v-bind:key="index" class="col-md-12 border-bottom item-rel-movprodutos">
                                <div class="row">                                                                     
                                    <div class="col-md-1">
                                        <span class="tit-item">{{item.idcobrador}}</span>
                                    </div>
                                    <div class="col-md-7">
                                        <span class="tit-item">{{item.nomecobrador}} ({{item.fatcomissao}}%)</span>
                                    </div>									
                                    <div class="col-md-1 text-right">
                                        <span class="tit-item">{{mtdformatavalordecimal(parseFloat(item.totalcobrador), 2)}}</span>
                                    </div>                                                                                                                                                                                                     
                                    <div class="col-md-2 text-right">
                                        <span class="tit-item">{{mtdformatavalordecimal(parseFloat(item.totalcomissao), 2)}}</span>
                                    </div>                                                                                
                                    <template v-if="parseInt(detalharcliente) === 1">
                                        <div v-for="(itemi, ind) in item.itens" v-bind:key="ind" class="col-md-12 item-rel-movprodutos" style="padding: 0px;">                                    
                                            <div class="row">                                                                      
                                                <div class="col-md-1">
                                                    
                                                </div>
                                                <div class="col-md-1">
                                                    <span class="tit-item-simples">{{itemi.codtit}}</span>
                                                </div>
                                                <div class="col-md-6">
                                                    <span class="tit-item-simples">{{itemi.nomecli}}</span>
                                                </div>                                                                                                                                                                                                                                                                                                                                                  
                                                <div class="col-md-1 text-right">
                                                    <span class="tit-item-simples">{{mtdformatavalordecimal(parseFloat(itemi.vlpagtit), 2)}}</span>
                                                </div>                                                                                                                           
                                                <div class="col-md-2 text-right">
                                                    <span class="tit-item-simples">{{mtdformatavalordecimal(parseFloat(itemi.totalcomissao), 2)}}</span>
                                                </div>                                                
                                            </div>
                                        </div>
                                    </template>                                   
                                </div>
                            </div>
                        </div>
                        <div v-show="parseInt(idrelatorio) === 8 && lstcobradores.length > 0" class="dvrodaperelatorios">
                            <div class="col-md-12 border-top" style="padding-top: 15px;">
                                <div class="row">                                                                                                                                                                                                                                                                
                                    <div class="col-md-2">
                                        <span class="tit-item">TOTAIS:</span>
                                    </div>  
                                    <div class="col-md-2 text-right">
                                        <span class="tit-item">{{mtdformatavalordecimal(parseFloat(totalgeraltits), 2)}}</span>
                                    </div>                                   
                                    <div class="col-md-6 text-right">
                                        <span class="tit-item">{{mtdformatavalordecimal(parseFloat(totalgeralcomissaocob), 2)}}</span>
                                    </div>                                                                                                    		                                                          
                                </div>
                            </div>                            
                        </div>                                                                        
                    </div>
                </div>        
            </div>            
        </div>

		<!-- Modal paginação tabela de preços -->
		<div class="modal fade" id="mdpaginacaotabelasprecos">
			<div class="modal-dialog modal-md modal-dialog-centered">
			<div class="modal-content">
				<div class="modal-header">
					<h4 class="modal-title" style="font-size: 16px;"><i class="fa fa-file"></i> Definir paginação</h4>
					<button type="button" class="close" data-dismiss="modal">&times;</button>
				</div>				
				<div class="modal-body">
					<div class="row">
						<div class="col-6">
                            <label for="edpaginacao">Paginação:</label>
                            <input type="number" v-model="idpaginacao"
                                class="form-control form-control-sm" id="edpaginacao" min="1">
						</div>		
						<div class="col-6">
                            <label for="editenspagina">Itens p/ pagina:</label>
                            <input type="number" v-model="itenspagina"
                                class="form-control form-control-sm" id="editenspagina" min="100">
						</div>		                        
					</div>
				</div>
				<div class="modal-footer">
					<button type="button" class="btn btn-primary btn-sm" data-dismiss="modal" style="width: 150px;" @click.prevent="mtdopcoestabelasprecos(0, true)"><i class="fa fa-print"></i> Imprimir</button>
					<button type="button" class="btn btn-success btn-sm" data-dismiss="modal" style="width: 150px;" @click.prevent="mtdopcoestabelasprecos(1, true)"><i class="fa fa-file-excel-o"></i> Exportar excel</button>
					<button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal" style="width: 100px;"><i class="fa fa-close"></i> Cancelar</button>
				</div>				        
			</div>
			</div>
		</div>				        
    </div>
</template>        
<script>
    import ConsultarProdutos from '../components/cmpconsultarprodutos.vue'
    import util from '../utilitarios/util.js'
    import * as moment from 'moment';
    import GraficoDoughnut from '../components/cmpgraficodoughnut.vue';
    import GraficoPie from '../components/cmpgraficopie.vue';
    import GraficoLine from '../components/cmpgraficoline.vue';
    export default {
        name: 'relestoque',
        components:{
            'consultaprodutos'  : ConsultarProdutos,
            'graficodoughnut'   : GraficoDoughnut,
            'graficopie'		: GraficoPie,
            'graficoline'		: GraficoLine,
           /// 'graficomapa'		: Graficomapa
        },
        data: function() {
            return {                
                idrelatorio         : 0,//0 - listagem dos relatórios
                utodasfiliais 		: this.$store.state.usuario.todasfiliais,
                idfilial            : null,
				dtini       		: util.DataAtual(true),
				dtfim       		: util.DataAtual(true),

                //para visualização na consulta de produtos
                idtabela            : 1,
                showprtabela		: false,
                tipopropesquisa     : '',

                idcliente           : null,
                //comuns a todos os relatórios
                idrota              : null,
                idestoque           : null,
                idmarca             : null,
                idgrupo             : null,
                idsubgrupo          : null,
                idsetor             : null,
                idtabela            : null,
                idvendedor          : null,
                idtecnico           : null,
                idservico           : null,
                idcobrador          : null,

                //vendas de produtos                
                idproduto           : '',
                coddig              : '',
                descricaoproduto    : '',
                lstvendasprodutos   : [],
                totalvendasprodutos : 0,
                totalcustoprodutos  : 0,
                quantitativoprodutos: 0,
                qtditensprodutos    : 0,
                ticketmedioprodutos : 0,                
                ordem               : 'order by 3 asc',
                ordemserv           : 'order by 4 asc',

                //vendas de serviços
                lstvendasservicos   : [],
                totalvendasservicos : 0,
                quantitativoservicos: 0,
                legendastecnicos    : [],
                dadostecnicos       : [],                                

                //mapa de vendas
                lstmapavendas       : [],
                agrupamento         : 0,
                totalgeralcusto     : 0,
                totalgeralvenda     : 0,
                totaldiferenca      : 0,
                margemgeral         : 0,
                legendasvendedor    : [],
                dadosvendedor       : [],
                legendasmarcas      : [],
                dadosmarcas         : [],
                legendasgrupos      : [],
                dadosgrupos         : [],
                legendassubgrupos   : [],
                dadossubgrupos      : [],
                legendassetores     : [],
                dadossetores        : [],                
                legendasplanos      : [],
                dadosplanos         : [],
                legendasformas      : [],
                dadosformas         : [],
                legendasfilial      : [],
                dadosfilial         : [],

                dadosmunicipios     : [],
                legendasmunicipios  : [],
                
                vendas              : false,
                variacao            : false,
                filiais             : false,
                formaspagto         : false,
                planos              : false,
                marcas              : false,
                grupos              : false,
                subgrupo            : false,
                setor               : false,
                vendedores          : false,
                municipios          : false,
                idmunicipio         : null,
                /////////////////////////////
                
                //vendas de clientes
                lstvendasclientes   : [],
                totalgeralcustocliente: 0,
                totalgeralvendacliente: 0,
                detalharcliente       : 0,  

                //movimentos dos pdvs
                idpdv               : null,
                idabertura          : '',
                idgruposaidapdv     : null,
                lstaberturas        : [],
                ltotalaberturas     : 0,
                lstentradas         : [],
                ltotalentradas      : 0,
                lstrecebimentos     : [],
                ltotalrecebimentos  : 0,
                lstvendas           : [],
                ltotalvendas        : 0,
                ltotalcanceladas    : 0,
                lstsaidas           : [],
                ltotalsaidas        : 0,
                lstfechamentos      : [],
                ltotalregistrado    : 0,
                ltotalfechamento    : 0,
                ltotaldiferenca     : 0,
                lstformas           : [],
                lstgrupossaidas     : [],

                //comissao de vendedores
                lstvendedores       : [],
                tpcomissao          : 0,
                tpdetalhecomissao   : 0,
                totalgeralvenda     : 0,
                totalgeralcomissao  : 0,

                //comissao de cobradores
                lstcobradores          : [],
                totalgeraltits         : 0,
                totalgeralcomissaocob  : 0,
                
                //tabelas de preços
                opestoque           : 0,
                idclasse            : null,
                lsttabelasprecos    : [],
                classeselecionada   : [],
                idpaginacao         : 1,
                itenspagina         : 200,
                oppreco             : 0,


                agrupamentograficoline : [],
                seriesgraficoline      : [], 
                options: {
                    format           : 'DD/MM/YYYY',
                    useCurrent       : false,
                    locale           : 'pt-BR'
                }                
            }
        },
        methods:{
            mtdformatardthr(dtstr){
               return moment(dtstr).format('DD/MM/YYYY hh:mm'); 
            },
			mtdformatavalordecimal(valor, digitos){
				return util.formatavalordecimais(valor, digitos);
			},               
			mtdformatarzeros(str, length){
				return util.formatarzeros(str, length);
            },
            mtdlocalizaopcao(opcoes, valor){                
                for (let i = 0; i < opcoes.length; i++) {
                    if (parseInt(opcoes[i]) === parseInt(valor)){
                        return true;
                    }                    
                }
                return false;
            },
            mtdverificaselecoesmapavendas(){
                let vself                 = this;
                let opcoes                = $('#sbvisualizar').selectpicker('val');
                vself.vendas              = vself.mtdlocalizaopcao(opcoes, 0);
                vself.variacao            = vself.mtdlocalizaopcao(opcoes, 1);
                vself.filiais             = vself.mtdlocalizaopcao(opcoes, 2);
                vself.formaspagto         = vself.mtdlocalizaopcao(opcoes, 3);
                vself.planos              = vself.mtdlocalizaopcao(opcoes, 4);
                vself.marcas              = vself.mtdlocalizaopcao(opcoes, 5);
                vself.grupos              = vself.mtdlocalizaopcao(opcoes, 6);
                vself.subgrupo            = vself.mtdlocalizaopcao(opcoes, 7);
                vself.setor               = vself.mtdlocalizaopcao(opcoes, 8);
                vself.vendedores          = vself.mtdlocalizaopcao(opcoes, 9);
                vself.municipios          = vself.mtdlocalizaopcao(opcoes, 10);
            },            
            mtddefinicoesiniais(){
                let vself = this;
				let sqliniusuario = parseInt(vself.utodasfiliais) === 0 ? 'select f.codfil, f.fantasia from tbfiliaisusuario fu left join tbfiliais f on f.codfil=fu.idfilial ' : 'select codfil, fantasia from tbfiliais ';
				let sqlfimusuario = parseInt(vself.utodasfiliais) === 0 ? 'where upper(f.fantasia) like upper("%@@%") and fu.idusuario='+vself.$store.state.usuario.id 		 : 'where upper(fantasia) like upper("%@@%")';                

                $('#sbvisualizar').selectpicker({
                    noneResultsText : 'Sem resultados',
                    noneSelectedText: 'Nenhuma selecionada',
                    selectAllText   : 'Todas',
                    deselectAllText : 'Nenhuma',
                    dropupAuto      : false

                });
                $('#sbvisualizar').selectpicker('selectAll');

                $('#sbvisualizar').on('changed.bs.select', function (e, clickedIndex, isSelected, previousValue) {
                    vself.mtdverificaselecoesmapavendas();
                });

				$("#cbfilial").select2({
					id: function (e) {return e.codfil},
					ajax: {						
						url: vself.$store.state.configpaths.pathselect2sql,						
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q		: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								sqlini	: sqliniusuario,
								sqlfim	: sqlfimusuario,
								cpid	: 'codfil',
								cpdesc	: 'fantasia'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.idfilial = $("#cbfilial").val();
				});
				$("#cbcliente").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbclientes',
								c1: 'id',
								c2: 'nome'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.idcliente = $("#cbcliente").val();
				});  
                
                $("#cbrota").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbrotas',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.idrota = $("#cbrota").val();
                });

                $("#cbmunicipios").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbmunicipios',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.idmunicipio = $("#cbmunicipios").val();
                });

                $("#cbmarca").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbmarcas',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.idmarca = $("#cbmarca").val();
                });
                $("#cbgrupo").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbgrupos',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.idgrupo = $("#cbgrupo").val();
                });
                $("#cbsubgrupo").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbsubgrupos',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.idsubgrupo = $("#cbsubgrupo").val();
                }); 
                $("#cbpdv").select2({
                    id: function (e) {return e.id},
                    ajax: {
                        url: vself.$store.state.configpaths.pathselect2,
                        dataType: 'json',
                        delay: 250,
                        data: function (params) {
                            return {
                                q: params.term,
                                idclientesac : vself.$store.state.filialpadrao.idcliente,
                                tb: 'tbpdvs',
                                c1: 'id',
                                c2: 'descricao'
                            };
                        },
                        processResults: function (data) {
                            return {
                                results: data
                            };
                        },
                        cache: true
                    },
                    minimumInputLength: 0,
                    theme: 'bootstrap',
                    language: "pt-BR",
                    templateResult: util.formatResult,
                    templateSelection: util.formatSelection
                }).change(function () {
                    vself.idpdv = $("#cbpdv").val();
                });                           				            
				$("#cbgruposaidapdv").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbgrupossaidaspdv',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.idgruposaidapdv = $("#cbgruposaidapdv").val();
				});
                
                $("#cbsetor").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbsetoresprodutos',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.idsetor = $("#cbsetor").val();
                });

                $("#cbtabela").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbtabelasprecos',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.idtabela = $("#cbtabela").val();
                    vself.lsttabelasprecos = [];
                });

				$('#mdpaginacaotabelasprecos').on('shown.bs.modal', function (e) {
					$('#edpaginacao').focus();
				});                

                $("#cbvendedor").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbvendedores',
                                    c1: 'id',
                                    c2: 'nome'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.idvendedor = $("#cbvendedor").val();
                });

                $("#cbcobrador").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbcobradores',
                                    c1: 'id',
                                    c2: 'nome'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.idcobrador = $("#cbcobrador").val();
                });

				$("#cbestoque").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbestoques',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
                    vself.idestoque = $("#cbestoque").val();
                });                

                $("#cbtecnico").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbtecnicos',
                                    c1: 'id',
                                    c2: 'nome'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.idtecnico = $("#cbtecnico").val();
                });

                $("#cbservico").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbservicos',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.idservico = $("#cbservico").val();
                });

                $('#sbmovimentos').selectpicker({
                    noneResultsText : 'Sem resultados',
                    noneSelectedText: 'Nenhum selecionado',
                    selectAllText   : 'Todos',
                    deselectAllText : 'Nenhum'

                });
                $('#sbmovimentos').selectpicker('selectAll'); 
                
                vself.mtdverificaselecoesmapavendas();
            },
            mtdlimparcampos(){
                this.lstvendasprodutos      = [];
                this.lstmapavendas          = []; 
                this.lstvendasservicos      = [];
                this.totalvendasservicos    = 0;
                this.quantitativoservicos   = 0;
                this.idproduto              = '';
                this.coddig                 = '';
                this.descricaoproduto       = '';
                this.idmarca                = null;
                this.idgrupo                = null;
                this.idsubgrupo             = null;
                this.idsetor                = null;
                this.idservico              = null;
                this.ordem                  = 'order by 3 asc';
                this.agrupamento            = 0;
                this.idpdv                  = null;
                this.idabertura             = '';
                $("#cbmarca").val(null).trigger('change');
                $("#cbgrupo").val(null).trigger('change');
                $("#cbsubgrupo").val(null).trigger('change');
                $("#cbsetor").val(null).trigger('change');
                $("#cbcliente").val(null).trigger('change');
                $("#cbvendedor").val(null).trigger('change');
                $("#cbtecnico").val(null).trigger('change');
                $("#cbservico").val(null).trigger('change');
                $("#cbpdv").val(null).trigger('change');
                $('#sbmovimentos').selectpicker('selectAll');            
            },
            mtdvisualizarel(oprel){                
                return util.opcaousuario(oprel, this.$store.state.perfilusuario);
            },
            mtddefinerelatorio(id){                
                this.mtdlimparcampos();
                this.idrelatorio            = id;
                setTimeout(() => {
                    this.ordem                  = parseInt(this.idrelatorio) !== 7 ? 'order by i.idproduto asc' : 'order by 2 asc';                    
                    switch (id){
                        case 1:                          
                            $('#edidproduto').focus();
                        break;
                        case 2:
                            $('#edidproduto').focus();
                        break;
                        case 3:
                            $('#cbpdv').select2('open');
                        break;                                                
                        case 5: case 6:
                            $('#cbcliente').select2('open');
                        break;                         
                    }
                }, 200);
            },
            mtdlocalizarproduto(coddig){
				if (coddig !== '' && coddig !== null){
					var vself       = this;
					let loader      = vself.$loading.show();
					let parametros  = [
						{parametro: 'op',               valor : 'listagem'},
						{parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
						{parametro: 'diretorioimagens', valor : vself.$store.state.configpaths.pathimgprodutos+vself.$store.state.filialpadrao.idcliente},
						{parametro: 'filtro',           valor : ''},
						{parametro: 'coddig',           valor : coddig},
						{parametro: 'limit',            valor : 1},
						{parametro: 'offset',           valor : 0},
					];
					let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadprodutos.php');
					retorno.then(function (response) {
						loader.hide();						
						if (response.data.length > 0){
							let produto = response.data[0];							
							vself.idproduto			= produto.id;
							vself.descricaoproduto 	= produto.descricao;
						}else{
							vself.$toastr.w('Código informado não cadastrado no sistema!', 'Atenção!');
							$('#edidproduto').focus();
						}
					}).catch(function (response) {
						loader.hide();
					});
				}else{
                    this.idproduto          = '';
                    this.descricaoproduto 	= '';
                }
            },			            
            mtdconsultarproduto(){
                let payload = {
                    abrirtela    : true			
                };
                this.$store.commit('CONSULTA_PRODUTO_CHANGE',payload);
                let payloadx = {
                    idproduto    : null			
                };
                this.$store.commit('PRODUTO_RETORNO_CHANGE',payloadx);                
			},
            mtdexecutarelatorio(idrelatorio){
                switch (idrelatorio){
                    case 1:                        
                        this.mtdrelatoriovendasprodutos();
                    break;
                    case 2:                        
                        this.mtdrelatoriomapavendas();
                    break;
                    case 3:                        
                        this.mtdrelatoriomovimentospdvs();
                    break;
                    case 4:
                        this.mtdrelatoriovendasservicos();
                    break; 
                    case 5:
                        this.mtdrelatoriovendasclientes()
                    break;
                    case 6:
                        this.mtdrelatoriocomissaovendedores();
                    break; 
                    case 7:
                        this.mtdrelatoriotabelasprecos();
                    break;    
                    case 8:
                        this.mtdrelatoriocomissaocobradores();
                    break;                                                                     
                }
            },
            mtdrelatoriovendasprodutos(){
                let vself   = this;
                let filtro  = ' and pd.dtfatura between "' + util.InverterData(this.dtini) + ' 00:00:00" and "' + util.InverterData(this.dtfim) + ' 23:59:59"';

                let filtrog = ' and pg.dtfatura between "' + util.InverterData(this.dtini) + ' 00:00:00" and "' + util.InverterData(this.dtfim) + ' 23:59:59"';

				if (vself.idfilial !== null){
					filtro  = filtro  + ' and pd.idfilial='+vself.idfilial;
                    filtrog = filtrog + ' and pg.idfilial='+vself.idfilial;
				}
				if (vself.idcliente !== null){
					filtro  = filtro  + ' and pd.idcliente='+vself.idcliente;
                    filtrog = filtrog + ' and pg.idcliente='+vself.idcliente;
				}                
				if (vself.idproduto !== '' && vself.idproduto !== null){
					filtro  = filtro  + ' and i.idproduto='+vself.idproduto;
				}                
				if (vself.idrota !== null){
					filtro  = filtro  + ' and cd.idrota='+vself.idrota;
                    filtrog = filtrog + ' and cg.idrota='+vself.idrota;
				}
				if (vself.idmarca !== null){
					filtro  = filtro  + ' and p.idmarca='+vself.idmarca;
				} 
				if (vself.idgrupo !== null){
					filtro  = filtro  + ' and p.idgrupo='+vself.idgrupo;
				}                               
				if (vself.idsubgrupo !== null){
					filtro  = filtro  + ' and p.idsubgrupo='+vself.idsubgrupo;
				}
				if (vself.idsetor !== null){
					filtro  = filtro  + ' and p.idsetor='+vself.idsetor;
				}
				if (vself.idtabela !== null){
					filtro  = filtro  + ' and pp.idtabela='+vself.idtabela;
				}                

				if (vself.idvendedor !== null){
					filtro  = filtro  + ' and pd.idvendedor='+vself.idvendedor;
				}                                

                let loader      			= vself.$loading.show();
                let parametros  			= [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           	valor : 'vendasprodutos'},
                    {parametro: 'filtro', 	        valor : filtro},
                    {parametro: 'filtrogeral',      valor : filtrog},
                    {parametro: 'ordem',            valor : vself.ordem},
                    {parametro: 'dias', 	        valor : util.diferencaentredatas(util.InverterData(vself.dtfim), util.InverterData(vself.dtini))},
                    {parametro: 'idfilial',         valor : vself.idfilial !== null ? vself.idfilial : 0},
                    {parametro: 'dtini',            valor : util.InverterData(this.dtini)},
                    {parametro: 'dtfim',            valor : util.InverterData(this.dtfim)},
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtrelatorios.php');
                retorno.then(function (response) {
                    vself.lstvendasprodutos   = response.data.produtos;
                    vself.totalvendasprodutos = response.data.totalvenda;
                    vself.totalcustoprodutos  = response.data.totalgeralcusto;
                    vself.quantitativoprodutos= response.data.quantitativo;
                    vself.qtditensprodutos    = response.data.qtditens;
                    vself.ticketmedioprodutos = parseFloat(vself.quantitativoprodutos) > 0 ? parseFloat(vself.totalvendasprodutos) / parseFloat(vself.quantitativoprodutos) : 0;
                    loader.hide();		
                }).catch(function (response) {
                    vself.lstvendasprodutos     = [];
                    vself.totalvendasprodutos   = 0;
                    vself.totalcustoprodutos    = 0;
                    vself.quantitativoprodutos  = 0;
                    vself.qtditensprodutos      = 0;                    
                    vself.ticketmedioprodutos   = 0;
                    loader.hide();
                });                
            },
            mtdrelatoriomapavendas(){
                let vself   = this;
                let filtro  = ' and p.dtfatura between "' + util.InverterData(this.dtini) + ' 00:00:00" and "' + util.InverterData(this.dtfim) + ' 23:59:59"';

				if (vself.idfilial !== null){
					filtro  = filtro  + ' and p.idfilial='+vself.idfilial;
				}
				if (vself.idcliente !== null){
					filtro  = filtro  + ' and p.idcliente='+vself.idcliente;
				}       
                if (vself.idvendedor !== null){
					filtro  = filtro  + ' and p.idvendedor='+vself.idvendedor;
				}     
				if (vself.idrota !== null){
					filtro  = filtro  + ' and c.idrota='+vself.idrota;
				}         
                if (vself.idmunicipio !== null){
					filtro  = filtro  + ' and c.idmunicipio='+vself.idmunicipio;
				}           
				if (vself.idproduto !== '' && vself.idproduto !== null){
					filtro = filtro + ' and pro.id='+vself.idproduto;
				}                
				if (vself.idmarca !== null){
					filtro = filtro + ' and pro.idmarca='+vself.idmarca;
				} 
				if (vself.idgrupo !== null){
					filtro = filtro + ' and pro.idgrupo='+vself.idgrupo;
				}                               
				if (vself.idsubgrupo !== null){
					filtro = filtro + ' and pro.idsubgrupo='+vself.idsubgrupo;
				}
				if (vself.idsetor !== null){
					filtro = filtro + ' and pro.idsetor='+vself.idsetor;
				}
                let loader      			= vself.$loading.show();
                let parametros  			= [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           	valor : 'mapavendas'},
                    {parametro: 'agrupamento',      valor : vself.agrupamento},
                    {parametro: 'filtro', 	        valor : filtro},
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtrelatorios.php');
                retorno.then(function (response) {
                    vself.lstmapavendas       = response.data.agrupamento;
                    vself.totalgeralcusto     = response.data.totalgeralcusto;
                    vself.totalgeralvenda     = response.data.totalgeralvenda;
                    vself.totaldiferenca      = response.data.totaldiferenca;
                    vself.margemgeral         = response.data.margemgeral; 

                    vself.dadosvendedor       = response.data.vendedores;
                    vself.legendasvendedor    = util.gerardadoslegendagrafico(vself.dadosvendedor);                    

                    vself.dadosmarcas         = response.data.marcas;                    
                    vself.legendasmarcas      = util.gerardadoslegendagrafico(vself.dadosmarcas);
                    
                    vself.dadosgrupos         = response.data.grupos;
                    vself.legendasgrupos      = util.gerardadoslegendagrafico(vself.dadosgrupos);                    
                    
                    vself.dadossubgrupos      = response.data.subgrupos;
                    vself.legendassubgrupos   = util.gerardadoslegendagrafico(vself.dadossubgrupos);                    

                    vself.dadossetores        = response.data.setores;
                    vself.legendassetores     = util.gerardadoslegendagrafico(vself.dadossetores);                                        
                    
                    vself.dadosplanos         = response.data.planos;
                    vself.legendasplanos      = util.gerardadoslegendagrafico(vself.dadosplanos);                    
                    
                    vself.dadosformas         = response.data.formas;                                
                    vself.legendasformas      = util.gerardadoslegendagrafico(vself.dadosformas);                    

                    vself.dadosfilial         = response.data.filiais;
                    vself.legendasfilial      = util.gerardadoslegendagrafico(vself.dadosfilial);       
                    
                    vself.dadosmunicipios     = response.data.municipios;
                    vself.legendasmunicipios  = util.gerardadoslegendagrafico(vself.dadosfilial);  

                    //gera os dados para o gráfico de linha custo/venda
                    vself.agrupamentograficoline = util.gerarseriegrafico(vself.lstmapavendas, 'agrupamento');
                    let seriecusto = {
                        name: 'Custo',
                        type: 'line',
                        data: util.gerarseriegrafico(vself.lstmapavendas, 'totalcusto')
                    };
                    let serievenda = {
                        name: 'Venda',
                        type: 'line',
                        data: util.gerarseriegrafico(vself.lstmapavendas, 'totalvenda')
                    };                    
                    vself.seriesgraficoline = [];
                    vself.seriesgraficoline.push(seriecusto);
                    vself.seriesgraficoline.push(serievenda);

                    loader.hide();		
                }).catch(function (response) {
                    vself.lstmapavendas   = [];
                    vself.totalgeralcusto = 0;
                    vself.totalgeralvenda = 0;
                    vself.totaldiferenca  = 0;
                    vself.margemgeral     = 0; 
                    vself.dadosvendedor       = [];
                    vself.legendasvendedor    = []                    

                    vself.dadosmarcas         = [];                    
                    vself.legendasmarcas      = []
                    
                    vself.dadosgrupos         = [];
                    vself.legendasgrupos      = []                    
                    
                    vself.dadossubgrupos      = [];
                    vself.legendassubgrupos   = []                    
                     
                    vself.dadosplanos         = [];
                    vself.legendasplanos      = []                    
                    
                    vself.dadosformas         = [];                                
                    vself.legendasformas      = [];                                                                       

                    vself.dadosfilial         = [];
                    vself.legendasfilial      = []; 
                    
                    vself.dadosmunicipios     = [];
                    vself.legendasmunicipios  = [];
                    loader.hide();
                });    
            },
            mtdvisualizamov(id){
               let ret = 0;
               let mov = $('#sbmovimentos').selectpicker('val');
               for (let i = 0; i < mov.length; i++) {
                   if (parseInt(mov[i]) === parseInt(id)){
                       ret = 1;
                       break;
                   }
               }
               return ret; 
            },            
            mtdrelatoriomovimentospdvs(){
                let vself   = this;
                let mov = $('#sbmovimentos').selectpicker('val');
                if (mov.length > 0){
                    let loader      			= vself.$loading.show();
                    let parametros  			= [
                        {parametro: 'idclientesac',     valor  : vself.$store.state.filialpadrao.idcliente},
                        {parametro: 'op',           	valor : 'movimentospdvs'},
                        {parametro: 'idfilial', 	    valor : vself.idfilial !== null ? vself.idfilial : 0},
                        {parametro: 'dtini',            valor : util.InverterData(vself.dtini) + ' 00:00:00'},                    
                        {parametro: 'dtfim',            valor : util.InverterData(vself.dtfim) + ' 23:59:59'},
                        {parametro: 'idpdv',            valor : vself.idpdv !== null ? vself.idpdv : 0},
                        {parametro: 'idgruposaidapdv',  valor : vself.idgruposaidapdv !== null ? vself.idgruposaidapdv : 0},
                        {parametro: 'idabertura',       valor : vself.idabertura},
                        {parametro: 'aberturas',        valor : vself.mtdvisualizamov(0)},
                        {parametro: 'vendas',           valor : vself.mtdvisualizamov(1)},
                        {parametro: 'recebimentos',     valor : vself.mtdvisualizamov(2)},
                        {parametro: 'entradas',         valor : vself.mtdvisualizamov(3)},
                        {parametro: 'saidas',           valor : vself.mtdvisualizamov(4)},
                        {parametro: 'fechamentos',      valor : vself.mtdvisualizamov(5)}
                    ];
                    let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtrelatorios.php');
                    retorno.then(function (response) {
                        vself.lstaberturas        = response.data.aberturas;
                        vself.ltotalaberturas     = response.data.totalaberturas;
                        vself.lstentradas         = response.data.entradas;
                        vself.ltotalentradas      = response.data.totalentradas;
                        vself.lstrecebimentos     = response.data.recebimentos;
                        vself.ltotalrecebimentos  = response.data.totalrecebimentos;  
                        vself.lstvendas           = response.data.pedidos;
                        vself.ltotalvendas        = response.data.totalpedidos;
                        vself.ltotalcanceladas    = response.data.totalcanceladas;
                        vself.lstsaidas           = response.data.saidas;
                        vself.ltotalsaidas        = response.data.totalsaidas;
                        vself.lstfechamentos      = response.data.fechamentos;
                        vself.lstformas           = response.data.formas;

                        //agrupa as saídas
                        vself.lstgrupossaidas     = [];
                        for (let i = 0; i < vself.lstsaidas.length; i++){
                            if (vself.lstgrupossaidas.length > 0){
                                let indf = util.getArrayIndexForKey(vself.lstgrupossaidas, 'descgruposaida', vself.lstsaidas[i].descgruposaida);
                                if (indf !== -1){
                                    vself.lstgrupossaidas[indf].valor = parseFloat(vself.lstgrupossaidas[indf].valor) + parseFloat(vself.lstsaidas[i].valor);
                                    vself.lstgrupossaidas[indf].lancamentos.push(vself.lstsaidas[i]);
                                }else{
                                    let gptmp = {
                                        'descgruposaida' : vself.lstsaidas[i].descgruposaida,
                                        'valor'          : vself.lstsaidas[i].valor,
                                        'lancamentos'    : []
                                    };
                                    gptmp.lancamentos.push(vself.lstsaidas[i]);
                                    vself.lstgrupossaidas.push(gptmp);                                     
                                }
                            }else{
                               let gptmp = {
                                    'descgruposaida' : vself.lstsaidas[i].descgruposaida,
                                    'valor'          : vself.lstsaidas[i].valor,
                                    'lancamentos'    : []
                               };
                               gptmp.lancamentos.push(vself.lstsaidas[i]);
                               vself.lstgrupossaidas.push(gptmp); 
                            }
                        }
                        console.log(vself.lstgrupossaidas);

                        vself.ltotalregistrado		 = 0;
                        vself.ltotalfechamento		 = 0;
                        vself.ltotaldiferenca		 = 0;

                        if (vself.lstfechamentos.length > 0){
                            for (let fechamento of vself.lstfechamentos) {
                                for (let forma of fechamento.formas) {
                                    vself.ltotalregistrado		 = vself.ltotalregistrado + parseFloat(forma.valorregistrado);
                                    vself.ltotalfechamento		 = vself.ltotalfechamento + parseFloat(forma.valor);
                                }
                                vself.ltotaldiferenca = parseFloat(vself.ltotalfechamento) - parseFloat(vself.ltotalregistrado);						
                            }
                        }				

                        loader.hide();		
                    }).catch(function (response) {
                        vself.lstaberturas        = [];
                        vself.ltotalaberturas     = 0;
                        vself.lstentradas         = [];
                        vself.ltotalentradas      = 0;  
                        vself.lstrecebimentos     = [];
                        vself.ltotalrecebimentos  = 0;
                        vself.lstvendas           = [];
                        vself.ltotalvendas        = 0;
                        vself.ltotalcanceladas    = 0;  
                        vself.lstsaidas           = [];
                        vself.lstfechamentos      = [];
                        vself.lstformas           = [];

                        vself.ltotalregistrado		 = 0;
                        vself.ltotalfechamento		 = 0;
                        vself.ltotaldiferenca		 = 0;
                        loader.hide();
                    });                 
                }else{
					vself.$toastr.w('Informe ao menos um tipo de movimento!', 'Atenção!');
					$('#sbmovimentos').focus();					          
                }
            },
            mtdrelatoriovendasservicos(){
                let vself   = this;
                let filtro  = ' and p.dtfatura between "' + util.InverterData(this.dtini) + ' 00:00:00" and "' + util.InverterData(this.dtfim) + ' 23:59:59"';

                let filtrog = ' and pg.dtfatura between "' + util.InverterData(this.dtini) + ' 00:00:00" and "' + util.InverterData(this.dtfim) + ' 23:59:59"';

				if (vself.idfilial !== null){
					filtro  = filtro  + ' and p.idfilial='+vself.idfilial;
                    filtrog = filtrog + ' and pg.idfilial='+vself.idfilial;
				}
				if (vself.idcliente !== null){
					filtro  = filtro  + ' and p.idcliente='+vself.idcliente;
                    filtrog = filtrog + ' and pg.idcliente='+vself.idcliente;
				}                
				if (vself.idrota !== null){
					filtro  = filtro  + ' and c.idrota='+vself.idrota;
				}
				if (vself.idvendedor !== null){
					filtro  = filtro  + ' and p.idvendedor='+vself.idvendedor;
				}                                

				if (vself.idtecnico !== null){
					filtro  = filtro  + ' and sp.idtecnico='+vself.idtecnico;
				}   
                
				if (vself.idservico !== null){
					filtro  = filtro  + ' and sp.idservico='+vself.idservico;
				}                

                let loader      			= vself.$loading.show();
                let parametros  			= [
                    {parametro: 'idclientesac',     valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           	valor : 'vendasservicos'},
                    {parametro: 'filtro', 	        valor : filtro},
                    {parametro: 'filtrogeral',      valor : filtrog},
                    {parametro: 'ordem',            valor : vself.ordemserv},
                    {parametro: 'idfilial',         valor : vself.idfilial !== null ? vself.idfilial : 0},
                    {parametro: 'dias', 	        valor : util.diferencaentredatas(util.InverterData(vself.dtfim), util.InverterData(vself.dtini))}
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtrelatorios.php');
                retorno.then(function (response) {
                    vself.lstvendasservicos   = response.data.servicos;
                    vself.totalvendasservicos = response.data.totalvendaservicos;
                    vself.quantitativoservicos= response.data.quantitativo;

                    vself.dadostecnicos       = response.data.tecnicos;
                    vself.legendastecnicos    = util.gerardadoslegendagrafico(vself.dadostecnicos); 

                    loader.hide();		
                }).catch(function (response) {
                    vself.lstvendasservicos   = [];
                    vself.totalvendasservicos = 0;
                    vself.quantitativoservicos= 0;
                    loader.hide();
                });                
            },
            mtdrelatoriovendasclientes(){
                let vself   = this;
                let filtro  = ' and p.dtfatura between "' + util.InverterData(this.dtini) + ' 00:00:00" and "' + util.InverterData(this.dtfim) + ' 23:59:59"';

				if (vself.idfilial !== null){
					filtro  = filtro  + ' and p.idfilial='+vself.idfilial;
				}
				if (vself.idcliente !== null){
					filtro  = filtro  + ' and p.idcliente='+vself.idcliente;
				}       
				if (vself.idrota !== null){
					filtro  = filtro  + ' and c.idrota='+vself.idrota;
				}                         
				if (vself.idvendedor !== null){
					filtro = filtro + ' and p.idvendedor='+vself.idvendedor;
				}

				if (vself.idmarca !== null){
					filtro  = filtro  + ' and pro.idmarca='+vself.idmarca;
				} 
				if (vself.idgrupo !== null){
					filtro  = filtro  + ' and pro.idgrupo='+vself.idgrupo;
				}                               
				if (vself.idsubgrupo !== null){
					filtro  = filtro  + ' and pro.idsubgrupo='+vself.idsubgrupo;
				}
				if (vself.idsetor !== null){
					filtro  = filtro  + ' and pro.idsetor='+vself.idsetor;
				}

                let loader      			= vself.$loading.show();
                let parametros  			= [
                    {parametro: 'idclientesac',     valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           	valor : 'vendasclientes'},
                    {parametro: 'filtro', 	        valor : filtro},
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtrelatorios.php');
                retorno.then(function (response) {
                    vself.lstvendasclientes      = response.data.vendas;
                    vself.totalgeralcustocliente = response.data.totalgeralcusto;
                    vself.totalgeralvendacliente = response.data.totalgeralvenda;

                    loader.hide();		
                }).catch(function (response) {
                    vself.lstvendasclientes      = [];
                    vself.totalgeralcustocliente = 0;
                    vself.totalgeralvendacliente = 0;

                    loader.hide();
                });
            },
            mtdrelatoriocomissaovendedores(){//tpcomissao: 0 - Faturamento, 1 - Externa
                
                let vself   = this;
                let filtro = '';
                let filtroper = '';
     

                if(parseInt(vself.tpcomissao) !==3){
                    filtro  = ' and p.dtfatura between "' + util.InverterData(this.dtini) + ' 00:00:00" and "' + util.InverterData(this.dtfim) + ' 23:59:59"';
                }else{
                    filtroper  = 'between "' + util.InverterData(this.dtini) + ' 00:00:00" and "' + util.InverterData(this.dtfim) + ' 23:59:59"';
                    filtro = '';
                }
                
                if(parseInt(vself.tpcomissao) !==3){
                    if (vself.idrota !== null){
					    filtro  = filtro  + ' and c.idrota='+vself.idrota;
				    }                
                    if (vself.idfilial !== null){
                        filtro  = filtro  + ' and p.idfilial='+vself.idfilial;
                    }
                    if (vself.idcliente !== null){
                        filtro  = filtro  + ' and p.idcliente='+vself.idcliente;
                    }                
                    if (vself.idvendedor !== null){
                        filtro = filtro + ' and p.idvendedor='+vself.idvendedor;
                    }
                }else{
                    if (vself.idrota !== null){ 
					    filtro  = filtro  + ' and c.idrota='+vself.idrota;
				    }                
                    if (vself.idfilial !== null){
                        filtro  = filtro  + ' and p.idfilial='+vself.idfilial;
                    }
                    if (vself.idcliente !== null){
                        filtro  = filtro  + ' and c.id='+vself.idcliente;
                    }                
                    if (vself.idvendedor !== null){
                        filtro  = filtro  +' and p.idvendedor='+vself.idvendedor;
                    }
                }

				
                let strcomissao = '';
                switch (parseInt(vself.tpcomissao)) {
                    case 0:
                        strcomissao = 'comissaofaturamento';
                        break;
                    case 1:
                        strcomissao = 'comissaovendaexterna';
                        break;                        
                    case 2:
                        strcomissao = 'comissaoproduto';
                        break;      
                    case 3:
                    strcomissao = 'comissaoliquidez';
                    break;                      
                }
                let loader      			= vself.$loading.show();
                let parametros  			= [
                    {parametro: 'idclientesac',     valor : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           	valor : strcomissao},
                    {parametro: 'filtro', 	        valor : filtro},
                    {parametro: 'filtroper', 	    valor : filtroper},
                    {parametro: 'tpdetalhecomissao',valor : vself.tpdetalhecomissao},
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtrelatorios.php');
                retorno.then(function (response) {
          
                    vself.lstvendedores      = response.data.vendedores;
                    vself.totalgeralcomissao = response.data.totalgeralcomissao;
                    vself.totalgeralvenda    = response.data.totalgeralvendas;
               
            
                    loader.hide();		
                }).catch(function (response) {
                    vself.lstvendedores      = [];
                    vself.totalgeralcomissao = 0;
                    vself.totalgeralvenda    = 0;

                    loader.hide();
                });                
            },      
            mtdrelatoriocomissaocobradores(){
                let vself   = this;
                let filtro  = 't.dtpagtit between "' + util.InverterData(this.dtini) + '" and "' + util.InverterData(this.dtfim) + '"';

				if (vself.idrota !== null){
					filtro  = filtro  + ' and c.idrota='+vself.idrota;
				}                
				if (vself.idfilial !== null){
					filtro  = filtro  + ' and t.idfilial='+vself.idfilial;
				}
				if (vself.idcobrador !== null){
					filtro = filtro + ' and t.idcobrador='+vself.idcobrador;
				}

                let loader      			= vself.$loading.show();
                let parametros  			= [
                    {parametro: 'idclientesac',     valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           	valor : 'comissaocobrador'},
                    {parametro: 'filtro', 	        valor : filtro},
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtrelatorios.php');
                retorno.then(function (response) {
                    vself.lstcobradores         = response.data.cobradores;
                    vself.totalgeralcomissaocob = response.data.totalgeralcomissao;
                    vself.totalgeraltits       = response.data.totalgeraltits;

                    loader.hide();		
                }).catch(function (response) {
                    vself.lstcobradores         = [];
                    vself.totalgeralcomissaocob = 0;
                    vself.totalgeraltits        = 0;

                    loader.hide();
                });                
            },     
            mtdexportarrelatorio(idrelatorio, excel){
                let vself   = this;
                let filtro  = '';
                let filtrog = '';
                let filial  = vself.idfilial === null ? 'TODAS AS FILIAIS' : $('#cbfilial').select2('data')[0]['text'];
                switch (idrelatorio) {
                    case 1:
                            filtro  = ' and pd.dtfatura between "' + util.InverterData(this.dtini) + ' 00:00:00" and "' + util.InverterData(this.dtfim) + ' 23:59:59"';

                            filtrog = ' and pg.dtfatura between "' + util.InverterData(this.dtini) + ' 00:00:00" and "' + util.InverterData(this.dtfim) + ' 23:59:59"';

                            if (vself.idfilial !== null){
                                filtro  = filtro  + ' and pd.idfilial='+vself.idfilial;
                                filtrog = filtrog + ' and pg.idfilial='+vself.idfilial;
                            }
                            if (vself.idcliente !== null){
                                filtro  = filtro  + ' and pd.idcliente='+vself.idcliente;
                                filtrog = filtrog + ' and pg.idcliente='+vself.idcliente;
                            }                
                            if (vself.idproduto !== '' && vself.idproduto !== null){
                                filtro  = filtro  + ' and i.idproduto='+vself.idproduto;
                            }                

                            if (vself.idrota !== null){
                                filtro  = filtro  + ' and cd.idrota='+vself.idrota;
                                filtrog = filtrog + ' and cg.idrota='+vself.idrota;
                            }

                            if (vself.idmarca !== null){
                                filtro  = filtro  + ' and p.idmarca='+vself.idmarca;
                            } 
                            if (vself.idgrupo !== null){
                                filtro  = filtro  + ' and p.idgrupo='+vself.idgrupo;
                            }                               
                            if (vself.idsubgrupo !== null){
                                filtro  = filtro  + ' and p.idsubgrupo='+vself.idsubgrupo;
                            }
                            if (vself.idsetor !== null){
                                filtro  = filtro  + ' and p.idsetor='+vself.idsetor;
                            }
                            if (vself.idtabela !== null){
                                filtro  = filtro  + ' and pp.idtabela='+vself.idtabela;
                            }                

                            if (vself.idvendedor !== null){
                                filtro  = filtro  + ' and pd.idvendedor='+vself.idvendedor;
                            } 
                            let dias = util.diferencaentredatas(util.InverterData(vself.dtfim), util.InverterData(vself.dtini))
                            let idfil = vself.idfilial !== null ? vself.idfilial : 0
                            window.open(vself.$store.state.configpaths.pathcontrole+'rtrelatorios.php?idclientesac='+
                                        vself.$store.state.filialpadrao.idcliente+
                                        '&oprelatorio=8'+
                                        '&filtro='+filtro+
                                        '&filtrogeral='+filtrog+
                                        '&filial='+filial+
                                        '&agrupamento='+vself.agrupamento+
                                        '&ordem='+vself.ordem+
                                        '&dtini='+vself.dtini+
                                        '&idfilial='+idfil+
                                        '&dias='+dias+
                                        '&excel='+excel+
                                        '&dtfim='+vself.dtfim+
                                        '&usuario='+vself.$store.state.usuario.nome, '_blank');                               
                    break;

                    case 2:
                             filtro  = ' and p.dtfatura between "' + util.InverterData(this.dtini) + ' 00:00:00" and "' + util.InverterData(this.dtfim) + ' 23:59:59"';

                            if (vself.idfilial !== null){
                                filtro  = filtro  + ' and p.idfilial='+vself.idfilial;
                            }
                            if (vself.idcliente !== null){
                                filtro  = filtro  + ' and p.idcliente='+vself.idcliente;
                            }       
                            if (vself.idvendedor !== null){
                                filtro  = filtro  + ' and p.idvendedor='+vself.idvendedor;
                            }     
                            if (vself.idrota !== null){
                                filtro  = filtro  + ' and c.idrota='+vself.idrota;
                            }         
                            if (vself.idmunicipio !== null){
                                filtro  = filtro  + ' and c.idmunicipio='+vself.idmunicipio;
                            }           
                            if (vself.idproduto !== '' && vself.idproduto !== null){
                                filtro = filtro + ' and pro.id='+vself.idproduto;
                            }                
                            if (vself.idmarca !== null){
                                filtro = filtro + ' and pro.idmarca='+vself.idmarca;
                            } 
                            if (vself.idgrupo !== null){
                                filtro = filtro + ' and pro.idgrupo='+vself.idgrupo;
                            }                               
                            if (vself.idsubgrupo !== null){
                                filtro = filtro + ' and pro.idsubgrupo='+vself.idsubgrupo;
                            }
                            if (vself.idsetor !== null){
                                filtro = filtro + ' and pro.idsetor='+vself.idsetor;
                            }
                            
                            window.open(vself.$store.state.configpaths.pathcontrole+'rtrelatorios.php?idclientesac='+
                                        vself.$store.state.filialpadrao.idcliente+
                                        '&oprelatorio=4'+
                                        '&filtro='+filtro+
                                        '&filial='+filial+
                                        '&agrupamento='+vself.agrupamento+
                                        '&opcoes='+$('#sbvisualizar').selectpicker('val')+
                                        '&dtini='+vself.dtini+
                                        '&excel='+excel+
                                        '&dtfim='+vself.dtfim+
                                        '&usuario='+vself.$store.state.usuario.nome, '_blank');
                    break;
                    case 3:
                        let mov = $('#sbmovimentos').selectpicker('val');
                        let idgruposaidapdv = vself.idgruposaidapdv !== null ? vself.idgruposaidapdv : 0;
                        let idpdv           = vself.idpdv !== null ? vself.idpdv : 0
                        let idfilmov        = vself.idfilial !== null ? vself.idfilial : 0
                        let dtinirelpdv = util.InverterData(vself.dtini) + ' 00:00:00'                    
                        let dtfimrelpdv = util.InverterData(vself.dtfim) + ' 23:59:59'
                        if (mov.length > 0){

                            window.open(vself.$store.state.configpaths.pathcontrole+'rtrelatorios.php?idclientesac='+
                                        vself.$store.state.filialpadrao.idcliente+
                                        '&oprelatorio=11'+
                                        '&filial='+filial+
                                        '&idfilial='+idfilmov+
                                        '&idpdv='+idpdv+
                                        '&idabertura='+vself.idabertura+
                                        '&idgruposaidapdv='+idgruposaidapdv+
                                        '&dtini='+dtinirelpdv+
                                        '&aberturas='+vself.mtdvisualizamov(0)+
                                        '&vendas='+vself.mtdvisualizamov(1)+
                                        '&recebimentos='+vself.mtdvisualizamov(2)+
                                        '&entradas='+vself.mtdvisualizamov(3)+
                                        '&saidas='+vself.mtdvisualizamov(4)+
                                        '&fechamentos='+vself.mtdvisualizamov(5)+
                                        '&excel='+excel+
                                        '&dtfim='+dtfimrelpdv+
                                        '&usuario='+vself.$store.state.usuario.nome, '_blank');
                        }
                    break;
                    case 4:
                            filtro  = ' and p.dtfatura between "' + util.InverterData(this.dtini) + ' 00:00:00" and "' + util.InverterData(this.dtfim) + ' 23:59:59"';

                            filtrog = ' and pg.dtfatura between "' + util.InverterData(this.dtini) + ' 00:00:00" and "' + util.InverterData(this.dtfim) + ' 23:59:59"';

                            if (vself.idfilial !== null){
                                filtro  = filtro  + ' and p.idfilial='+vself.idfilial;
                                filtrog = filtrog + ' and pg.idfilial='+vself.idfilial;
                            }
                            if (vself.idcliente !== null){
                                filtro  = filtro  + ' and p.idcliente='+vself.idcliente;
                                filtrog = filtrog + ' and pg.idcliente='+vself.idcliente;
                            }                
                            if (vself.idrota !== null){
                                filtro  = filtro  + ' and c.idrota='+vself.idrota;
                            }
                            if (vself.idvendedor !== null){
                                filtro  = filtro  + ' and p.idvendedor='+vself.idvendedor;
                            }                                

                            if (vself.idtecnico !== null){
                                filtro  = filtro  + ' and sp.idtecnico='+vself.idtecnico;
                            }   

                            if (vself.idservico !== null){
                                filtro  = filtro  + ' and sp.idservico='+vself.idservico;
                            }   
                            let diasser = util.diferencaentredatas(util.InverterData(vself.dtfim), util.InverterData(vself.dtini))
                            let idfilser = vself.idfilial !== null ? vself.idfilial : 0
                            window.open(vself.$store.state.configpaths.pathcontrole+'rtrelatorios.php?idclientesac='+
                                        vself.$store.state.filialpadrao.idcliente+
                                        '&oprelatorio=9'+
                                        '&filtro='+filtro+
                                        '&filtrogeral='+filtrog+
                                        '&filial='+filial+
                                        '&agrupamento='+vself.agrupamento+
                                        '&ordem='+vself.ordem+
                                        '&dtini='+vself.dtini+
                                        '&idfilial='+idfilser+
                                        '&dias='+diasser+
                                        '&excel='+excel+
                                        '&dtfim='+vself.dtfim+
                                        '&usuario='+vself.$store.state.usuario.nome, '_blank');         
          
                    
                    break;
                    case 5:
                         filtro  = ' and p.dtfatura between "' + util.InverterData(this.dtini) + ' 00:00:00" and "' + util.InverterData(this.dtfim) + ' 23:59:59"';

                        if (vself.idfilial !== null){
                            filtro  = filtro  + ' and p.idfilial='+vself.idfilial;
                        }
                        if (vself.idcliente !== null){
                            filtro  = filtro  + ' and p.idcliente='+vself.idcliente;
                        }       
                        if (vself.idrota !== null){
                            filtro  = filtro  + ' and c.idrota='+vself.idrota;
                        }                         
                        if (vself.idvendedor !== null){
                            filtro = filtro + ' and p.idvendedor='+vself.idvendedor;
                        }
                        window.open(vself.$store.state.configpaths.pathcontrole+'rtrelatorios.php?idclientesac='+
                                        vself.$store.state.filialpadrao.idcliente+
                                        '&oprelatorio=7'+
                                        '&filtro='+filtro+
                                        '&filial='+filial+
                                        '&detalhar='+vself.detalharcliente+
                                        '&dtini='+vself.dtini+
                                        '&excel='+excel+
                                        '&dtfim='+vself.dtfim+
                                        '&usuario='+vself.$store.state.usuario.nome, '_blank');
                                            
                    break;
                    case 6:

                  
                        let filtroper  = "";

                        if(parseInt(vself.tpcomissao) !==3){
                            filtro  = ' and p.dtfatura between "' + util.InverterData(this.dtini) + ' 00:00:00" and "' + util.InverterData(this.dtfim) + ' 23:59:59"';
                        }else{
                            filtroper  = 'between "' + util.InverterData(this.dtini) + ' 00:00:00" and "' + util.InverterData(this.dtfim) + ' 23:59:59"';
                            filtro = '';
                        }
                        
                        if(parseInt(vself.tpcomissao) !==3){
                            if (vself.idrota !== null){
                                filtro  = filtro  + ' and c.idrota='+vself.idrota;
                            }                
                            if (vself.idfilial !== null){
                                filtro  = filtro  + ' and p.idfilial='+vself.idfilial;
                            }
                            if (vself.idcliente !== null){
                                filtro  = filtro  + ' and p.idcliente='+vself.idcliente;
                            }                
                            if (vself.idvendedor !== null){
                                filtro = filtro + ' and p.idvendedor='+vself.idvendedor;
                            }
                        }else{
                            if (vself.idrota !== null){ 
                                filtro  = filtro  + ' and c.idrota='+vself.idrota;
                            }                
                            if (vself.idfilial !== null){
                                filtro  = filtro  + ' and p.idfilial='+vself.idfilial;
                            }
                            if (vself.idcliente !== null){
                                filtro  = filtro  + ' and c.id='+vself.idcliente;
                            }                
                            if (vself.idvendedor !== null){
                                filtro  = filtro  +' and p.idvendedor='+vself.idvendedor;
                            }
                        }

                        let tpcomis =  vself.tpcomissao // 0 - comissaofaturamento,  1 - comissaovendaexterna, 2  -  comissaoproduto - 3 liquidez
                        window.open(vself.$store.state.configpaths.pathcontrole+'rtrelatorios.php?idclientesac='+
                                        vself.$store.state.filialpadrao.idcliente+
                                        '&oprelatorio=10'+
                                        '&filtro='+filtro+
                                        '&filial='+filial+
                                        '&tpdetalhecomissao='+vself.tpdetalhecomissao+
                                        '&detalhar='+vself.detalharcliente+
                                        '&tpcomis='+tpcomis+
                                        '$filtroper'+filtroper+
                                        '&excel='+excel+
                                        '&dtini='+vself.dtini+
                                        '&dtfim='+vself.dtfim+
                                        '&usuario='+vself.$store.state.usuario.nome, '_blank');
 
                    break;
                    case 8:
                             filtro  = 't.dtpagtit between "' + util.InverterData(this.dtini) + '" and "' + util.InverterData(this.dtfim) + '"';
                            if (vself.idrota !== null){
                                filtro  = filtro  + ' and c.idrota='+vself.idrota;
                            }                
                            if (vself.idfilial !== null){
                                filtro  = filtro  + ' and t.idfilial='+vself.idfilial;
                            }
                            if (vself.idcobrador !== null){
                                filtro = filtro + ' and t.idcobrador='+vself.idvendedor;
                            }
                            window.open(vself.$store.state.configpaths.pathcontrole+'rtrelatorios.php?idclientesac='+
                                        vself.$store.state.filialpadrao.idcliente+
                                        '&oprelatorio=6'+
                                        '&filtro='+filtro+
                                        '&filial='+filial+
                                        '&agrupamento='+vself.agrupamento+
                                        '&detalhar='+vself.detalharcliente+
                                        '&excel='+excel+
                                        '&dtini='+vself.dtini+
                                        '&dtfim='+vself.dtfim+
                                        '&usuario='+vself.$store.state.usuario.nome, '_blank');
                    break;    
                }
            },   
            mtdrelatoriotabelasprecos(){
                let vself   = this;
                let filtro  = '';
				if (vself.idmarca !== null){
					filtro  = filtro  + ' and p.idmarca='+vself.idmarca;
				} 
				if (vself.idgrupo !== null){
					filtro  = filtro  + ' and p.idgrupo='+vself.idgrupo;
				}                               
				if (vself.idsubgrupo !== null){
					filtro  = filtro  + ' and p.idsubgrupo='+vself.idsubgrupo;
				}
				if (vself.idsetor !== null){
					filtro  = filtro  + ' and p.idsetor='+vself.idsetor;
				}

                let loader      			= vself.$loading.show();
                let parametros  			= [
                    {parametro: 'idclientesac',     valor : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           	valor : 'tabelasprecos'},
                    {parametro: 'idtabela',         valor : vself.idtabela !== null ? vself.idtabela : ''},
                    {parametro: 'idfilial',         valor : vself.idfilial !== null ? vself.idfilial : 0},
                    {parametro: 'filtro', 	        valor : filtro},
                    {parametro: 'idestoque',        valor : vself.idestoque !== null ? vself.idestoque : 0},
                    {parametro: 'opestoque',        valor : vself.opestoque},
                    {parametro: 'oppreco',          valor : vself.oppreco},
                    {parametro: 'ordem',            valor : vself.ordem}
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtrelatorios.php');
                retorno.then(function (response) {
                    vself.lsttabelasprecos = response.data.produtos;
                    loader.hide();		
                }).catch(function (response) {
                    vself.lsttabelasprecos = [];
                    loader.hide();
                });                
            },
            mtdopcoestabelasprecos(exportar, pg){
                let vself   = this;
                let filtro  = '';
				if (vself.idmarca !== null){
					filtro  = filtro  + ' and p.idmarca='+vself.idmarca;
				} 
				if (vself.idgrupo !== null){
					filtro  = filtro  + ' and p.idgrupo='+vself.idgrupo;
				}                               
				if (vself.idsubgrupo !== null){
					filtro  = filtro  + ' and p.idsubgrupo='+vself.idsubgrupo;
				}
				if (vself.idsetor !== null){
					filtro  = filtro  + ' and p.idsetor='+vself.idsetor;
				}                
                let idfilial  = vself.idfilial  !== null ? vself.idfilial : 0;    
                let idtabela  = vself.idtabela  !== null ? vself.idtabela : '';
                let idestoque = vself.idestoque !== null ? vself.idestoque : 0;
                
                let oppg = '&pagina=0&itenspagina=0';
                if (pg){
                    oppg = '&pagina='+vself.idpaginacao+'&itenspagina='+vself.itenspagina;
                }
				window.open(vself.$store.state.configpaths.pathcontrole+'rtrelatorios.php?idclientesac='+
							vself.$store.state.filialpadrao.idcliente+
							'&oprelatorio=5'+
                            '&filtro='+filtro+
                            '&idfilial='+idfilial+
                            '&idtabela='+idtabela+
                            '&idestoque='+idestoque+
                            '&opestoque='+vself.opestoque+
                            '&oppreco='+vself.oppreco+
                            '&ordem='+vself.ordem+
                            '&usuario='+vself.$store.state.usuario.nome+
                            '&exportar='+exportar+
                            oppg, '_blank');
            },
            mtdexportarexcel(){
                $('#btexportarexcel').click();
            },
            mtddefinirpaginicao(){
                $('#mdpaginacaotabelasprecos').modal('show');
            }
        },
        mounted: function () {
            if (util.verificasessao(this)) {
                let vself = this;
                let loader = vself.$loading.show();
                let parametros = [
                    {parametro: 'op',           valor: 'dadosusuario'},
                    {parametro: 'idclientesac', valor  : vself.$store.state.usuario.idclientesac},
                    {parametro: 'idusuario',    valor: vself.$store.state.usuario.id}
                ];
                let retorno = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rotinasusuario.php');
                retorno.then(function (response) {
                    loader.hide();
                    vself.$store.commit('MUDAR_PERFIL_USUARIO', response.data.perfilusu);
                    if (util.opcaousuario('040Z.020Z', vself.$store.state.perfilusuario)) {
                        vself.mtddefinicoesiniais();
                    } else {
                        vself.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                        setTimeout(function(){
                            util.gotoprincipal();
                        },1000);
                    }
                }).catch(function (response) {
                    loader.hide();
                    console.log(response.message);
                });
            }
        },
        computed:{
            idprodutoretorno(){
                return this.$store.state.produtoretornoconsulta.idproduto;
            }        
        },
        watch:{
            idprodutoretorno(val){
                if (val !== null || val !== ''){
					this.coddig = val;
					this.mtdlocalizarproduto(this.coddig);					
                }
			},
            tpdetalhecomissao(val){
                this.lstvendedores = [];
            }            
        }
    }
</script>
<style>
    @media print {
        .lista-card-graficos{
            height: auto!important;
        }
        #dv-titulo-relatorio{
           padding-top: 0px!important; 
           border-right: 0px!important;
        }        
        .nao-imprimir{
            display: none!important;
        }
    }
    .dvwhite{
        padding-top: 15px;
        padding-bottom: 15px;
        background: white;
    }
    .tit-item{
        font-size: 12px;
        font-weight: 700;
    }
    .tit-item-simples{
        font-size: 12px;
    }
    .item-rel-movprodutos{
        cursor: pointer;
        padding: 10px;
    }
    .item-rel-movprodutos:hover{
        background: #eeeded66;
    }
    .item-mov{
        font-size: 10px;
        font-weight: 600;
    }
    .item-elipse{
        position: absolute;
        top: 5px; 
        max-width: 90px; 
        overflow: hidden; 
        text-overflow: ellipsis; 
        white-space: nowrap;        
    }
    .dvrelaconteudorelatorios{
        /* height: 400px; */
        overflow: auto;
        width: 100%;        
    }    
    .dvrodaperelatorios{
        margin-bottom: 10px;
        overflow: auto;
        width: 100%;        
    }
    .bdg-desc-prom{
        float: right;
        left: 2px;
    }
    @media (max-width: 576px) {
        .grafico-individual .echarts {
            width: 300px;
            height: 400px;
        }        
        .grafico-line-faturamento .echarts{
            width: 300px;
            height: 250px;        
        }        
    }  
    @media (min-width: 577px) {
        .grafico-individual .echarts {
            width: 500px;
            height: 600px;
        }        
        .grafico-line-faturamento .echarts{
            width: 550px;
            height: 220px;        
        }        
    }  
    @media (min-width: 1024px) {
        .grafico-individual .echarts {
            width: 1024px;
            height: 828px;
        }       
        .grafico-line-faturamento .echarts{
            width: 1024px;
            height: 400px;        
        }        
    }        
    .lblforma-rel-tb{
        font-size: 10px;
    }
    .lblforma-rel-tb-vl{
        font-size: 12px;
        font-weight: 600;
    }    
</style>